import React, { useEffect, useState } from "react";
import { Card, CardHeader } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { signupservices } from "../../services/signupservices";
import * as BullCache from "../../util/BullCache";
import { customStyles, modelDropdown, the } from "../components/customStyles";
import "../custom.css";
import { NumberToWordFormatter } from "../components/NumberToWordFormatter";
import { isMobile } from "../../util/GeneralUtil";
import { NewAccountService } from "../../services/NewAccountService";
import { QuantitySettingsService } from "../../services/QuantitySettingsService";

function EditAccount() {
  var adminId = BullCache.getFromCache("user");
  var allScripts = BullCache.getFromCache("allScripts");

  const location = useLocation();
  const { rowId, adminIdMaster, userId } = location.state || {};

  const [isCheckedGlobal, setIsCheckedGlobal] = useState(false);
  const [isCheckedNSE, setIsCheckedNSE] = useState(false);
  const [isCheckedMCX, setIsCheckedMCX] = useState(false);
  const [isCheckedNCDEX, setIsCheckedNCDEX] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalMCX, setShowModalMCX] = useState(false);
  const [showModalNSE, setShowModalNSE] = useState(false);
  const [showModalNCDEX, setShowModalNCDEX] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [userName, setUserName] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionMCX, setSelectedOptionMCX] = useState(null);
  const [selectedOptionNSE, setSelectedOptionNSE] = useState(null);
  const [selectedOptionNCDEX, setSelectedOptionNCDEX] = useState(null);
  const [subBrokerDropdown, setSubBrokerDropdown] = useState(null);
  const [copySettingOptions, setCopySettingOptions] = useState([]);
  const [
    copySettingNSEForBrokerageDetails,
    setCopySettingNSEForBrokerageDetails,
  ] = useState(null);
  const [copySettingNSEForMarginDetails, setCopySettingNSEForMarginDetails] =
    useState(null);
  const [marginDetailsNSELot, setMarginDetailsNSELot] = useState();
  const [marginDetailsNSEAmount, setMarginDetailsNSEAmount] = useState();
  const [marginDetailsINDEXLot, setMarginDetailsINEDXLot] = useState();
  const [marginDetailsINDEXAmount, setMarginDetailsINDEXAmount] = useState();
  const [selectedBroker1, setSelectedBroker1] = useState("");
  const [
    scriptDetailsIndexRadioSelection,
    setScriptDetailsIndexRadioSelection,
  ] = useState("ALLOW");
  const [scriptDeatailsDropdownIndex, setScriptDeatailsDropdownIndex] =
    useState([]);
  const [blockedScriptDropdownIndex, setBlockedScriptDropdownIndex] = useState(
    []
  );
  const [indexScriptToWork, setIndexScriptToWork] = useState();
  const [indexFreshLimitAllowed, setIndexFreshLimitAllowed] = useState(false);
  const [copySettingNSEForOtherDetails, setCopySettingNSEForOtherDetails] =
    useState(null);

  const [copySettingNSEForQuantitySettings,
      setCopySettingNSEForQuantitySettings] = useState(null);  
  const [copySettingMCXForQuantitySettings,
      setCopySettingMCXForQuantitySettings] = useState(null);
  const [copySettingGLOBALForQuantitySettings,
      setCopySettingGLOBALForQuantitySettings] = useState(null);

  const [NseScriptToWork, setNSEScriptToWork] = useState();
  const [ncdexScriptToWork, setNcdexScriptToWork] = useState();
  const [mcxFreshLimitAllowed, setMcxFreshLimitAllowed] = useState(false);
  const [mcxScriptToWork, setMCXScriptToWork] = useState();
  const [nseFreshLimitAllowed, setNseFreshLimitAllowed] = useState(false);
  const [ncdexFreshLimitAllowed, setNcdexFreshLimitAllowed] = useState(false);

  // const [selectedBroker2, setSelectedBroker2] = useState("");
  const [inputFields, setInputFields] = useState([
    { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForINDEXBroker1, setInputFieldsINDEXForBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForINDEXBroker2, setInputFieldsINDEXForBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);

  const [inputFieldsForNSEBroker1, setInputFieldsForNSEBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForNSEBroker2, setInputFieldsForNSEBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForMCXBroker1, setInputFieldsForMCXBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForMCXBroker2, setInputFieldsForMCXBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForNCDEXBroker1, setInputFieldsForNCDEXBroker1] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsForNCDEXBroker2, setInputFieldsForNCDEXBroker2] = useState([
    { id: 1, selectedScript: "ALL", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsNSE, setInputFieldsNSE] = useState([
    { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsMCX, setInputFieldsMCX] = useState([
    { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
  ]);
  const [inputFieldsNCDEX, setInputFieldsNCDEX] = useState([
    { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
  ]);

  const [quantitysettingsNSE, setQuantitysettingsNSE] = useState([
    { id: 1, segment: "NSE", script:"ALL", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null },
  ]);
  const [quantitysettingsMCX, setQuantitysettingsMCX] = useState([
    { id: 1, segment: "MCX", script:"ALL", type:"LOT", minOrder: null, maxOrder: null, positionLimit: null },
  ]);
  const [quantitysettingsGLOBAL, setQuantitysettingsGLOBAL] = useState([
    { id: 1, segment: "GLOBAL", script:"ALL", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null },
  ]);
  
  const [m2mLinkWithLedger, setm2mLinkWithLedger] = useState(false);

  const adminChange2 = (e) => {
    setSelectedRole(e.target.value);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === "index") {
      setIsCheckedGlobal(checked);
    } else if (name === "nse") {
      setIsCheckedNSE(checked);
    } else if (name === "mcx") {
      setIsCheckedMCX(checked);
    } else if (name === "ncdex") {
      setIsCheckedNCDEX(checked);
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleOpenModalMCX = () => {
    setShowModalMCX(true);
  };

  const handleCloseModalMCX = () => {
    setShowModalMCX(false);
  };
  const handleOpenModalNSE = () => {
    setShowModalNSE(true);
  };

  const handleCloseModalNSE = () => {
    setShowModalNSE(false);
  };
  const handleOpenModalNCDEX = () => {
    setShowModalNCDEX(true);
  };

  const handleCloseModalNCDEX = () => {
    setShowModalNCDEX(false);
  };
  const [copySetting, setCopySetting] = useState(null);
  const [customer, setCustomer] = useState([]);
  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);
  const [brokerageScripts, setBrokerageScripts] = useState([]);
  const [brokerageDropdown, setBrokerageDropdown] = useState([]);
  const [scriptDeatailsDropdown, setScriptDeatailsDropdown] = useState([]);
  const [scriptDetailsScript, setScriptDetailsScript] = useState([]);
  const [blockedScriptDropdown, setBlockedScriptDropdown] = useState([]);
  const [blockedScriptDetails, setBlockedScriptDetails] = useState([]);
  const [radioSelection, setRadioSelection] = useState("");
  const [marginDetailsRadioSelection, setMarginDetailsRadioSelection] =
    useState("LOT");
  const [marginDetailsCopySetting, setMarginDetailsCopySetting] = useState("");
  const [marginDetailsDelivery, setMarginDetailsDelivery] = useState("");
  const [marginDetails, setMarginDetails] = useState({});
  const [scriptDetailsRadioSelection, setScriptDetailsRadioSelection] =
    useState("");
  const [allowedScripts, setAllowedScripts] = useState([]);
  const [blockedScripts, setBlockedScripts] = useState([]);

  const [brokerageScriptsMCX, setBrokerageScriptsMCX] = useState([]);
  const [brokerageDropdownMCX, setBrokerageDropdownMCX] = useState([]);
  const [scriptDeatailsDropdownMCX, setScriptDeatailsDropdownMCX] = useState(
    []
  );
  const [scriptDetailsScriptMCX, setScriptDetailsScriptMCX] = useState([]);
  const [blockedScriptDropdownMCX, setBlockedScriptDropdownMCX] = useState([]);
  const [blockedScriptDetailsMCX, setBlockedScriptDetailsMCX] = useState([]);
  const [deliveryComMCX, setDeliveryComMCX] = useState("");
  const [intradayComMCX, setIntradayComMCX] = useState("");
  const [radioSelectionMCX, setRadioSelectionMCX] = useState("");
  const [marginDetailsRadioSelectionMCX, setMarginDetailsRadioSelectionMCX] =
    useState("LOT");
  const [marginDetailsMCXLot, setMarginDetailsMCXLot] = useState();
  const [marginDetailsMCXAmount, setMarginDetailsMCXAmount] = useState();
  const [marginDetailsDeliveryMCX, setMarginDetailsDeliveryMCX] = useState("");
  const [marginDetailsMCX, setMarginDetailsMCX] = useState({});
  const [scriptDetailsRadioSelectionMCX, setScriptDetailsRadioSelectionMCX] =
    useState("ALLOW");
  const [allowedScriptsMCX, setAllowedScriptsMCX] = useState([]);
  const [blockedScriptsMCX, setBlockedScriptsMCX] = useState([]);

  const [brokerageScriptsNSE, setBrokerageScriptsNSE] = useState([]);
  const [brokerageDropdownNSE, setBrokerageDropdownNSE] = useState([]);
  const [scriptDeatailsDropdownNSE, setScriptDeatailsDropdownNSE] = useState(
    []
  );
  const [scriptDetailsScriptNSE, setScriptDetailsScriptNSE] = useState([]);
  const [blockedScriptDropdownNSE, setBlockedScriptDropdownNSE] = useState([]);
  const [blockedScriptDetailsNSE, setBlockedScriptDetailsNSE] = useState([]);
  const [deliveryComNSE, setDeliveryComNSE] = useState("");
  const [intradayComNSE, setIntradayComNSE] = useState("");
  const [radioSelectionNSE, setRadioSelectionNSE] = useState("");
  const [marginDetailsRadioSelectionNSE, setMarginDetailsRadioSelectionNSE] =
    useState("LOT");
  const [marginDetailsCopySettingNSE, setMarginDetailsCopySettingNSE] =
    useState("");
  const [marginDetailsDeliveryNSE, setMarginDetailsDeliveryNSE] = useState("");
  const [marginDetailsNSE, setMarginDetailsNSE] = useState({});
  const [scriptDetailsRadioSelectionNSE, setScriptDetailsRadioSelectionNSE] =
    useState("ALLOW");
  const [allowedScriptsNSE, setAllowedScriptsNSE] = useState([]);
  const [blockedScriptsNSE, setBlockedScriptsNSE] = useState([]);

  const [brokerageScriptsNCDEX, setBrokerageScriptsNCDEX] = useState([]);
  const [brokerageDropdownNCDEX, setBrokerageDropdownNCDEX] = useState([]);
  const [scriptDeatailsDropdownNCDEX, setScriptDeatailsDropdownNCDEX] =
    useState([]);
  const [scriptDetailsScriptNCDEX, setScriptDetailsScriptNCDEX] = useState([]);
  const [blockedScriptDropdownNCDEX, setBlockedScriptDropdownNCDEX] = useState(
    []
  );
  const [blockedScriptDetailsNCDEX, setBlockedScriptDetailsNCDEX] = useState(
    []
  );
  const [deliveryComNCDEX, setDeliveryComNCDEX] = useState("");
  const [intradayComNCDEX, setIntradayComNCDEX] = useState("");
  const [radioSelectionNCDEX, setRadioSelectionNCDEX] = useState("");
  const [
    marginDetailsRadioSelectionNCDEX,
    setMarginDetailsRadioSelectionNCDEX,
  ] = useState("LOT");
  const [
    copySettingMCXForBrokerageDetails,
    setCopySettingMCXForBrokerageDetails,
  ] = useState(null);
  const [copySettingMCXForMarginDetails, setCopySettingMCXForMarginDetails] =
    useState(null);
  const [copySettingMCXForOtherDetails, setCopySettingMCXForOtherDetails] =
    useState(null);

  const [
    copySettingINDEXForBrokerageDetails,
    setCopySettingINDEXForBrokerageDetails,
  ] = useState(null);
  const [
    copySettingINDEXForMarginDetails,
    setCopySettingINDEXForMarginDetails,
  ] = useState(null);
  const [copySettingINDEXForOtherDetails, setCopySettingINDEXForOtherDetails] =
    useState(null);
  const [
    copySettingNCDEXForBrokerageDetails,
    setCopySettingNCDEXForBrokerageDetails,
  ] = useState(null);
  const [
    copySettingNCDEXForMarginDetails,
    setCopySettingNCDEXForMarginDetails,
  ] = useState(null);
  const [copySettingNCDEXForOtherDetails, setCopySettingNCDEXForOtherDetails] =
    useState(null);

  const [marginDetailsNCDEXLot, setMarginDetailsNCDEXLot] = useState();
  const [marginDetailsNCDEXAmount, setMarginDetailsNCDEXAmount] = useState();
  const [marginDetailsCopySettingNCDEX, setMarginDetailsCopySettingNCDEX] =
    useState("");
  const [marginDetailsDeliveryNCDEX, setMarginDetailsDeliveryNCDEX] =
    useState("");
  const [marginDetailsNCDEX, setMarginDetailsNCDEX] = useState({});
  const [
    scriptDetailsRadioSelectionNCDEX,
    setScriptDetailsRadioSelectionNCDEX,
  ] = useState("ALLOW");
  const [allowedScriptsNCDEX, setAllowedScriptsNCDEX] = useState([]);
  const [blockedScriptsNCDEX, setBlockedScriptsNCDEX] = useState([]);

  const [subBroker, setSubBroker] = useState([]);
  const [selectBrokerPartner, setSelectBrokerPartner] = useState("");
  const [selectBrokerPartner2, setSelectBrokerPartner2] = useState("");
  const [orderHighLow, setOrderHighLow] = useState(false);
  const [applyAutoSquare, setAutoSquare] = useState(false);
  const [tradeAllowed, setTradeAllowed] = useState(false);
  const [intraDayAutoSquare, setIntraDayAutoSquare] = useState(false);
  const [onlyPositionSquareOff, setOnlyPositionSquare] = useState(false);
  const [rollOver, setRollOver] = useState(false);
  const [onlyViewAccess, setOnlyViewAccess] = useState(false);
  const [bandScriptAllow, setBandScriptAllow] = useState(false);
  const [ledgerView, setLedgerView] = useState(true);
  const [selectedBroker, setSelectedBroker] = useState("");
  const [selectedBroker2, setSelectedBroker2] = useState("");
  const [editDataCustomer, setEditDataCustomer] = useState("");
  const [editDataAdmin, setEditDataAdmin] = useState("");
  const [minPerBrokeragePerClientINDEX, setMinPerBrokeragePerClientINDEX] =
    useState();
  const [maxMarginPerClientINDEX, setMaxMarginPerClientINDEX] = useState();
  const [minPerBrokeragePerClientNSE, setMinPerBrokeragePerClientNSE] =
    useState();
  const [maxMarginPerClientNSE, setMaxMarginPerClientNSE] = useState();
    const [minPerBrokeragePerClientMCX, setMinPerBrokeragePerClientMCX] = useState();
    const [minLotBrokeragePerClientMCX, setMinLotBrokeragePerClientMCX] = useState();
      const [maxMarginPerClientMCX, setMaxMarginPerClientMCX] = useState();
        const [maxLotPerClientMCX, setMaxLotPerClientMCX] = useState();
      const [minPerBrokeragePerClientNCDEX, setMinPerBrokeragePerClientNCDEX] = useState();
        const [minLotBrokeragePerClientNCDEX, setMinLotBrokeragePerClientNCDEX] = useState();
        const [maxMarginPerClientNCDEX, setMaxMarginPerClientNCDEX] = useState();
  const [
    inputFieldsMCXRatherThanCustomerType,
    setInputFieldsMCXRatherThanCustomerType,
  ] = useState([]);
  const fieldsToRenderMCXRatherThanCustomerType =
    inputFieldsMCXRatherThanCustomerType.length === 0
      ? []
      : inputFieldsMCXRatherThanCustomerType;
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    city: "",
    contactNo: "",
    partnership: "",
    brokerage: "",
    alert: "",
    orderLimit: "",
    squareOffDisabledInMin: "",
    m2mLoss: "",
    m2mProfit: "",
    m2mLinkedWithLedger: "",
    tradeBlockAbove: "",
    tradeBlockBelow: "",
  });
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const handleRadioChange = (value) => {
    setLedgerView(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    if (name === "firstName" && !value) {
      errorMessage = "* ";
    }
    if (name === "lastName" && !value) {
      errorMessage = "* ";
    }
    if (name === "partnership" && !value) {
      errorMessage = "* ";
    }
    if (name === "brokerage" && !value) {
      errorMessage = "* ";
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };

  useEffect(() => {
    signupservices.getSubBrokers({ adminId: adminId.adminId, userId: adminId.adminType === 'SUPER_ADMIN' ||  adminId.adminType === 'SUPER_MASTER' ? userId : null }).then((res) => {
      if (res.code === 1) {
        if (res.data.subbrokerList.length > 0) {
          setSubBroker(res.data.subbrokerList);
        }
      }
    });
    signupservices.getCustomer({ adminId: adminId.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.userList.length > 0) {
          setCustomer(res.data.userList);
        }
      }
    });
    signupservices.getBrokers({ adminId: adminId.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.brokerList.length > 0) {
          setBroker(res.data.brokerList);
        }
      }
    });
    signupservices.getMaster({ adminId: adminId.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.masterList.length > 0) {
          setMaster(res.data.masterList);
        }
      }
    });
  }, []);

  const options =
    selectedRole === "CUSTOMER"
      ? customer.map((customer) => ({
          value: customer.id,
          label: `${customer.firstName} ${customer.lastName} (${customer.userName})`,
        }))
      : selectedRole === "MASTER"
      ? master.map((master) => ({
          value: master.id,
          label: `${master.firstName} ${master.lastName} (${master.userName})`,
        }))
      : selectedRole === "BROKER"
      ? broker.map((broker) => ({
          value: broker.id,
          label: `${broker.firstName} ${broker.lastName} (${broker.userName})`,
        }))
      : selectedRole === "SUBBROKER"
      ? subBroker.map((subBroker) => ({
          value: subBroker.id,
          label: `${subBroker.firstName} ${subBroker.lastName} (${subBroker.userName})`,
        }))
      : null;

  const handleScriptDetailsDropdownINDEX = (selectedOptions) => {
    setScriptDeatailsDropdownIndex(
      selectedOptions ? selectedOptions?.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownIndex = (selectedOptions) => {
    setBlockedScriptDropdownIndex(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleCopySettingDropdownNSEForOtherDetails = (selected) => {
    setCopySettingNSEForOtherDetails(selected);
  };
  useEffect(() => {
    if (!adminIdMaster) return;
    signupservices
      .updateAdmin({ adminId: adminIdMaster })
      .then((res) => {
        if (res.code === 1 && res.data.ADMIN) {
          setEditDataAdmin(res?.data?.ADMIN);

         
        }
      })

      .catch((error) => {
        console.error("Error fetching admin data:", error);
      });
  }, [adminIdMaster]);

  useEffect(() => {
    // setLoading(true);
    NewAccountService.getCopySettings({
      adminId: adminId.adminId,
      accountType: selectedRole,
    }).then((resp) => {
      // setLoading(false);
      if (resp.code === 1) {
        setCopySettingOptions(resp?.data?.copySetting);
      }
    });
  }, [selectedRole]);

  useEffect(() => {
    if (editDataAdmin) {
      setSelectedRole(editDataAdmin?.adminType || "");
      setUserName(editDataAdmin?.userName || "");
      setFormData({
        firstName: editDataAdmin?.firstName || "",
        partnership: editDataAdmin?.accountDetails?.partnership || "",
      });
      setOrderHighLow(editDataAdmin?.accountDetails?.orderHighLow || false);
      setOnlyPositionSquare(
        editDataAdmin?.accountDetails?.onlyPositionSquareOff || false
      );
      setRollOver(editDataAdmin?.accountDetails?.rollOver || false);
      setOnlyViewAccess(editDataAdmin?.accountDetails?.onlyViewAccess || false);
      setLedgerView(editDataAdmin?.accountDetails?.ledgerView || false);
    }
  }, [editDataAdmin]);
  useEffect(() => {
    setSelectedRole(editDataCustomer?.adminType || "CUSTOMER");
    setUserName(editDataCustomer?.userName || "");
    setOrderHighLow(editDataCustomer?.accountDetails?.orderHighLow || false);
    setAutoSquare(editDataCustomer?.accountDetails?.applyAutoSquare || false);
    setIntraDayAutoSquare(
      editDataCustomer?.accountDetails?.intradaySquare || false
    );
    setOnlyPositionSquare(
      editDataCustomer?.accountDetails?.onlyPositionSquareOff || false
    );
    setRollOver(editDataCustomer?.accountDetails?.rollOver || false);
    setOnlyViewAccess(
      editDataCustomer?.accountDetails?.onlyViewAccess || false
    );
    setBandScriptAllow(
      editDataCustomer?.accountDetails?.bandScriptAllow || false
    );
    setm2mLinkWithLedger(
      editDataCustomer?.accountDetails?.m2mLinkedWithLedger || false
    );
    setLedgerView(editDataCustomer?.accountDetails?.ledgerView || false);
    setTradeAllowed(editDataCustomer?.accountDetails?.tradeAllowed || false);
    setFormData({
      firstName: editDataCustomer?.firstName || "",
      lastName: editDataCustomer?.lastName || "",
      email: editDataCustomer?.email || "",
      city: editDataCustomer?.city || "",
      contactNo: editDataCustomer?.contactNo || "",
      remark: editDataCustomer?.remark || "",
      partnership: editDataCustomer?.accountDetails?.partnership || "",
      brokerage: editDataCustomer?.accountDetails?.brokerage || "",
      alert: editDataCustomer?.accountDetails?.alert || "",
      orderLimit: editDataCustomer.accountDetails?.orderLimit || "",
      squareOffDisabledInMin:
        editDataCustomer?.accountDetails?.squareOffDisabledInMin || "",
      m2mLoss: editDataCustomer?.accountDetails?.m2mLoss || "",
      m2mProfit: editDataCustomer?.accountDetails?.m2mProfit || "",
      m2mLinkedWithLedger:
        editDataCustomer?.accountDetails?.m2mLinkedWithLedger || "",
      tradeBlockAbove: editDataCustomer?.accountDetails?.tradeBlockAbove || "",
      tradeBlockBelow: editDataCustomer?.accountDetails?.tradeBlockBelow || "",
    });
  }, [editDataCustomer]);
  useEffect(() => {
    if (editDataCustomer?.segments?.includes("MCX")) {
      setIsCheckedMCX(true);
    }
    if (editDataCustomer?.segments?.includes("GLOBAL")) {
      setIsCheckedGlobal(true);
    }
    if (editDataCustomer?.segments?.includes("NSE")) {
      setIsCheckedNSE(true);
    }
    if (editDataCustomer?.segments?.includes("NCDEX")) {
      setIsCheckedNCDEX(true);
    }
  }, [editDataCustomer, editDataCustomer?.segments]);
  useEffect(() => {
    if (editDataAdmin?.segments?.includes("MCX")) {
      setIsCheckedMCX(true);
    }
    if (editDataAdmin?.segments?.includes("GLOBAL")) {
      setIsCheckedGlobal(true);
    }
    if (editDataAdmin?.segments?.includes("NSE")) {
      setIsCheckedNSE(true);
    }
    if (editDataAdmin?.segments?.includes("NCDEX")) {
      setIsCheckedNCDEX(true);
    }
  }, [editDataAdmin, editDataAdmin?.segments]);

  //SubbrokerInfo1
  useEffect(() => {
    const brokerId = editDataCustomer?.subBrokerInfo1?.brokerId;
    const brokerPaternship =
      editDataCustomer?.subBrokerInfo1?.brokerPartnership;
    if (subBroker?.length > 0 && brokerId) {
      const brokerData = subBroker?.find((item) => item?.adminId === brokerId);
      if (brokerData) {
        setSelectedBroker1({
          value: brokerData?.adminId,
          label: `${brokerData?.firstName} (${brokerData?.userName})`,
        });
      }
      setSelectBrokerPartner(brokerPaternship);
    } 
  }, [editDataCustomer, editDataCustomer?.subBrokerInfo1, subBroker]);
  //SubbrokerInfo2
  useEffect(() => {
    const brokerId = editDataCustomer?.subBrokerInfo2?.brokerId;
    const brokerPaternship =
      editDataCustomer?.subBrokerInfo2?.brokerPartnership;
    if (subBroker?.length > 0 && brokerId) {
      const brokerData = subBroker?.find((item) => item?.adminId === brokerId);
      if (brokerData) {
        setSelectedBroker2({
          value: brokerData?.adminId,
          label: `${brokerData?.firstName} (${brokerData?.userName})`,
        });
      }
      setSelectBrokerPartner2(brokerPaternship);
    }
  }, [editDataCustomer, editDataCustomer?.subBrokerInfo2, subBroker]);

  // GLOBAL CUSTOMER DATA
  useEffect(() => {
    const brokerageDetails =
      editDataCustomer?.marketAccess?.globalSetting?.brokerageDetails;
    const marginDetails =
      editDataCustomer?.marketAccess?.globalSetting?.marginDetails || {};
    const otherDetails =
      editDataCustomer?.marketAccess?.globalSetting?.otherDetails || {};
    const broker1Details =
      editDataCustomer?.marketAccess?.globalSetting?.broker1;
    const broker2Details =
      editDataCustomer?.marketAccess?.globalSetting?.broker2;
    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelection(brokerageDetails[0]?.type != undefined ? brokerageDetails[0]?.type : "PERCENT");
      const updatedFields = brokerageDetails?.map((item) => ({
        id: uuidv4(),
        selectedScript: item?.script,
        deliveryCom: item?.deliveryCom,
        intradayCom: item?.intradayCom,
      }));

      setInputFields(updatedFields);
    } else {
       setRadioSelection("PERCENT");
    }
    if (marginDetails) {
      if (marginDetails?.lot > 0) {
        setMarginDetailsINEDXLot(marginDetails?.lot);
        setMarginDetailsRadioSelection("LOT");
        setMarginDetailsDelivery(marginDetails?.lot);
      } else
      if (marginDetails?.amount > 0 || marginDetails?.amount === 0) {
        setMarginDetailsINDEXAmount(marginDetails?.amount);
        setMarginDetailsRadioSelection("AMOUNT");
        setMarginDetailsDelivery(marginDetails?.amount);
      } else {
        setMarginDetailsRadioSelection("AMOUNT");
      }
    }
    if (otherDetails) {
      setIndexFreshLimitAllowed(otherDetails?.freshLimit != undefined ? otherDetails?.freshLimit : true);
      setIndexScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsIndexRadioSelection("ALLOW");
        setScriptDeatailsDropdownIndex(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsIndexRadioSelection("BLOCK");
        setBlockedScriptDropdownIndex(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
    if (broker1Details && broker1Details?.length > 0) {
      const updatedFieldsForBroker1 = broker1Details?.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));

      setInputFieldsINDEXForBroker1(updatedFieldsForBroker1);
    }
    if (broker2Details && broker2Details?.length > 0) {
      const updatedFieldsForBroker2 = broker2Details?.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));

      setInputFieldsINDEXForBroker2(updatedFieldsForBroker2);
    }

    var qtyDetails = editDataCustomer?.marketAccess?.globalSetting?.quantityDetails;
    if(qtyDetails && qtyDetails?.length > 0) {
      const updatedQtyDetails = qtyDetails?.map((item) => ({
        id: uuidv4(),
       ...item
      }));

      setQuantitysettingsGLOBAL(updatedQtyDetails);
    }

  }, [
    editDataCustomer,
    editDataCustomer?.marketAccess,
    editDataCustomer?.marketAccess?.globalSetting,
  ]);
  // GLOBAL ADMIN DATA
  useEffect(() => {
    const brokerageDetails =
      editDataAdmin?.marketAccess?.globalSetting?.brokerageDetails;
    const marginDetails =
      editDataAdmin?.marketAccess?.globalSetting?.marginDetails || {};
    const otherDetails =
      editDataAdmin?.marketAccess?.globalSetting?.otherDetails || {};
    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelection(brokerageDetails[0]?.type);
      // const updatedFields = brokerageDetails?.map((item) => ({
      //   id: uuidv4(),
      //   selectedScript: item?.script,
      //   deliveryCom: item?.deliveryCom,
      //   intradayCom: item?.intradayCom,
      // }));

      // setInputFields(updatedFields);
      setMinPerBrokeragePerClientINDEX(
        brokerageDetails[0]?.percent
      );
    } else{
      setRadioSelection("PERCENT");
    }
    if (marginDetails) {
      setMaxMarginPerClientINDEX(marginDetails?.maxMarginPerClient);
      if (marginDetails?.lot > 0) {
        setMarginDetailsINEDXLot(marginDetails?.lot);
        setMarginDetailsRadioSelection("LOT");
        setMarginDetailsDelivery(marginDetails?.lot);
      } else
      if (marginDetails?.amount > 0 || marginDetails?.amount === 0) {
        setMarginDetailsINDEXAmount(marginDetails?.amount);
        setMarginDetailsRadioSelection("AMOUNT");
        setMarginDetailsDelivery(marginDetails?.amount);
      } else{
        setMarginDetailsRadioSelection("AMOUNT");
      }
    }
    if (otherDetails) {
      setIndexFreshLimitAllowed(otherDetails?.freshLimit != undefined ? otherDetails?.freshLimit : true);
      setIndexScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsIndexRadioSelection("ALLOW");
        setScriptDeatailsDropdownIndex(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsIndexRadioSelection("BLOCK");
        setBlockedScriptDropdownIndex(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
  }, [
    editDataAdmin,
    editDataAdmin?.marketAccess,
    editDataAdmin?.marketAccess?.globalSetting,
  ]);

  // NSE CUSTOMER DATA
  useEffect(() => {
    const brokerageDetails =
      editDataCustomer?.marketAccess?.nseSetting?.brokerageDetails;
    const marginDetails =
      editDataCustomer?.marketAccess?.nseSetting?.marginDetails || {};
    const otherDetails =
      editDataCustomer?.marketAccess?.nseSetting?.otherDetails || {};
    const broker1Details = editDataCustomer?.marketAccess?.nseSetting?.broker1;
    const broker2Details = editDataCustomer?.marketAccess?.nseSetting?.broker2;
    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelectionNSE(brokerageDetails[0]?.type);
      const updatedFields = brokerageDetails?.map((item) => ({
        id: uuidv4(),
        selectedScript: item?.script,
        deliveryCom: item?.deliveryCom,
        intradayCom: item?.intradayCom,
      }));

      setInputFieldsNSE(updatedFields);
    } else{
       setRadioSelectionNSE("PERCENT");
    }
    if (marginDetails) {
      if (marginDetails?.lot > 0) {
        setMarginDetailsNSELot(marginDetails?.lot);
        setMarginDetailsRadioSelectionNSE("LOT");
        setMarginDetailsDeliveryNSE(marginDetails?.lot);
      } else if(marginDetails?.amount > 0 || marginDetails?.amount === 0) {
        setMarginDetailsNSEAmount(marginDetails?.amount);
        setMarginDetailsRadioSelectionNSE("AMOUNT");
        setMarginDetailsDeliveryNSE(marginDetails?.amount);
      } else{
        setMarginDetailsRadioSelectionNSE("AMOUNT");
      }
    }
    if (otherDetails) {
      setNseFreshLimitAllowed(otherDetails?.freshLimit != undefined ? otherDetails?.freshLimit : true);
      setNSEScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNSE("ALLOW");
        setScriptDeatailsDropdownNSE(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNSE("BLOCK");
        setBlockedScriptDropdownNSE(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
    if (broker1Details && broker1Details?.length > 0) {
      const updatedFieldsForBroker1 = broker1Details.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));

      setInputFieldsForNSEBroker1(updatedFieldsForBroker1);
    }
    if (broker2Details && broker2Details?.length > 0) {
      const updatedFieldsForBroker2 = broker2Details.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));
      setInputFieldsForNSEBroker2(updatedFieldsForBroker2);
    }

    var qtyDetails = editDataCustomer?.marketAccess?.nseSetting?.quantityDetails;
    if(qtyDetails && qtyDetails?.length > 0) {
      const updatedQtyDetails = qtyDetails?.map((item) => ({
        id: uuidv4(),
       ...item
      }));

      setQuantitysettingsNSE(updatedQtyDetails);
    }

  }, [
    editDataCustomer,
    editDataCustomer?.marketAccess,
    editDataCustomer?.marketAccess?.nseSetting,
  ]);
  // NSE ADMIN DATA
  useEffect(() => {
    const brokerageDetails =
      editDataAdmin?.marketAccess?.nseSetting?.brokerageDetails;
    const marginDetails =
      editDataAdmin?.marketAccess?.nseSetting?.marginDetails || {};
    const otherDetails =
      editDataAdmin?.marketAccess?.nseSetting?.otherDetails || {};
    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelectionNSE(brokerageDetails[0]?.type);
      setMinPerBrokeragePerClientNSE(
        brokerageDetails[0]?.percent
      );
    } else {
      setRadioSelectionNSE('PERCENT');
    }
    if (marginDetails) {
      setMaxMarginPerClientNSE(marginDetails?.maxMarginPerClient);
      if (marginDetails?.lot > 0) {
        setMarginDetailsNSELot(marginDetails?.lot);
        setMarginDetailsRadioSelectionNSE("LOT");
        setMarginDetailsDeliveryNSE(marginDetails?.lot);
      } else 
      if (marginDetails?.amount > 0 || marginDetails?.amount === 0) {
        setMarginDetailsNSEAmount(marginDetails?.amount);
        setMarginDetailsRadioSelectionNSE("AMOUNT");
        setMarginDetailsDeliveryNSE(marginDetails?.amount);
      } else {
         setMarginDetailsRadioSelectionNSE("AMOUNT");
      }
    }
    if (otherDetails) {
      setNseFreshLimitAllowed(otherDetails?.freshLimit != undefined ? otherDetails?.freshLimit : true );
      setNSEScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNSE("ALLOW");
        setScriptDeatailsDropdownNSE(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNSE("BLOCK");
        setBlockedScriptDropdownNSE(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
  }, [
    editDataAdmin,
    editDataAdmin?.marketAccess,
    editDataAdmin?.marketAccess?.nseSetting,
  ]);

  // MCX CUSTOMER DATA
  useEffect(() => {
    const brokerageDetails =
      editDataCustomer?.marketAccess?.mcxSetting?.brokerageDetails;
    const marginDetails =
      editDataCustomer?.marketAccess?.mcxSetting?.marginDetails || {};
    const otherDetails =
      editDataCustomer?.marketAccess?.mcxSetting?.otherDetails || {};
    const broker1Details = editDataCustomer?.marketAccess?.mcxSetting?.broker1;
    const broker2Details = editDataCustomer?.marketAccess?.mcxSetting?.broker2;
    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelectionMCX(brokerageDetails[0]?.type);
      const updatedFields = brokerageDetails?.map((item) => ({
        id: uuidv4(),
        selectedScript: item?.script,
        deliveryCom: item?.deliveryCom,
        intradayCom: item?.intradayCom,
      }));

      setInputFieldsMCX(updatedFields);
    } else {
       setRadioSelectionMCX("LOT");
    }
    if (marginDetails) {
      if (marginDetails?.amount > 0) {
        setMarginDetailsMCXAmount(marginDetails?.amount);
        setMarginDetailsRadioSelectionMCX("AMOUNT");
        setMarginDetailsDeliveryMCX(marginDetails?.amount);
      } else
      if (marginDetails?.lot === 0 || marginDetails?.lot > 0) {
        setMarginDetailsMCXLot(marginDetails?.lot);
        setMarginDetailsRadioSelectionMCX("LOT");
        setMarginDetailsDeliveryMCX(marginDetails?.lot);
      } else {
        setMarginDetailsRadioSelectionMCX("LOT");
      }
    }
    if (otherDetails) {
      setMcxFreshLimitAllowed(otherDetails?.freshLimit != undefined ? otherDetails?.freshLimit : true);
      setMCXScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionMCX("ALLOW");
        setScriptDeatailsDropdownMCX(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionMCX("BLOCK");
        setBlockedScriptDropdownMCX(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
    if (broker1Details && broker1Details?.length > 0) {
      const updatedFieldsForBroker1 = broker1Details.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));

      setInputFieldsForMCXBroker1(updatedFieldsForBroker1);
    }
    if (broker2Details && broker2Details?.length > 0) {
      const updatedFieldsForBroker2 = broker2Details.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));

      setInputFieldsForMCXBroker2(updatedFieldsForBroker2);
    }

    var qtyDetails = editDataCustomer?.marketAccess?.mcxSetting?.quantityDetails;
    if(qtyDetails && qtyDetails?.length > 0) {
      const updatedQtyDetails = qtyDetails?.map((item) => ({
        id: uuidv4(),
       ...item
      }));

      setQuantitysettingsMCX(updatedQtyDetails);
    }

  }, [
    editDataCustomer,
    editDataCustomer?.marketAccess,
    editDataCustomer?.marketAccess?.mcxSetting,
  ]);
  // MCX ADMIN DATA
  useEffect(() => {
    const brokerageDetails =
      editDataAdmin?.marketAccess?.mcxSetting?.brokerageDetails;
    const marginDetails =
      editDataAdmin?.marketAccess?.mcxSetting?.marginDetails || {};
    const otherDetails =
      editDataAdmin?.marketAccess?.mcxSetting?.otherDetails || {};

    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelectionMCX(brokerageDetails[0]?.type);
      setMinPerBrokeragePerClientMCX(
        brokerageDetails[0]?.percent)
        setMinLotBrokeragePerClientMCX(
          brokerageDetails[0]?.lot)
     
          const updatedFields = brokerageDetails
          ?.slice(1) // Skip the first element (index 0)
          .map((item) => ({
            id: uuidv4(),
            selectedScript: item?.script,
            mcxPercentage: item?.percent,
            mcxLot: item?.lot,
          }));
        setInputFieldsMCXRatherThanCustomerType(updatedFields);
    } else {
      setRadioSelectionMCX("LOT");
    }
    if (marginDetails) {
      setMaxMarginPerClientMCX(marginDetails?.maxMarginPerClient);
      setMaxLotPerClientMCX(marginDetails?.maxLotPerClient);
      if (marginDetails?.lot === 0 || marginDetails?.lot > 0) {
        setMarginDetailsMCXLot(marginDetails?.lot);
        setMarginDetailsRadioSelectionMCX("LOT");
        setMarginDetailsDeliveryMCX(marginDetails?.lot);
      } else
      if (marginDetails?.amount > 0 || marginDetails?.amount === 0) {
        setMarginDetailsMCXAmount(marginDetails?.amount);
        setMarginDetailsRadioSelectionMCX("AMOUNT");
        setMarginDetailsDeliveryMCX(marginDetails?.amount);
      }
    }

    if (otherDetails) {
      setMcxFreshLimitAllowed(otherDetails?.freshLimit != undefined ? otherDetails?.freshLimit : true);
      setMCXScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionMCX("ALLOW");
        setScriptDeatailsDropdownMCX(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionMCX("BLOCK");
        setBlockedScriptDropdownMCX(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
  }, [
    editDataAdmin,
    editDataAdmin?.marketAccess,
    editDataAdmin?.marketAccess?.mcxSetting,
  ]);

  // NCDEX CUSTOMER DATA
  useEffect(() => {
    const brokerageDetails =
      editDataCustomer?.marketAccess?.ncdexSetting?.brokerageDetails;
    const marginDetails =
      editDataCustomer?.marketAccess?.ncdexSetting?.marginDetails || {};
    const otherDetails =
      editDataCustomer?.marketAccess?.ncdexSetting?.otherDetails || {};
    const broker1Details =
      editDataCustomer?.marketAccess?.ncdexSetting?.broker1;
    const broker2Details =
      editDataCustomer?.marketAccess?.ncdexSetting?.broker2;
    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelectionNCDEX(brokerageDetails[0]?.type);
      const updatedFields = brokerageDetails?.map((item) => ({
        id: uuidv4(),
        selectedScript: item?.script,
        deliveryCom: item?.deliveryCom,
        intradayCom: item?.intradayCom,
      }));

      setInputFieldsNCDEX(updatedFields);
    }
    if (marginDetails) {
      if (marginDetails?.lot === 0 || marginDetails?.lot > 0) {
        setMarginDetailsNCDEXLot(marginDetails?.lot);
        setMarginDetailsRadioSelectionNCDEX("LOT");
        setMarginDetailsDeliveryNCDEX(marginDetails?.lot);
      }
      if (marginDetails?.amount > 0 || marginDetails?.amount === 0) {
        setMarginDetailsNCDEXAmount(marginDetails?.amount);
        setMarginDetailsRadioSelectionNCDEX("AMOUNT");
        setMarginDetailsDeliveryNCDEX(marginDetails?.amount);
      }
    }
    if (otherDetails) {
      setNcdexFreshLimitAllowed(otherDetails?.freshLimit);
      setNcdexScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNCDEX("ALLOW");
        setScriptDeatailsDropdownNCDEX(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNCDEX("BLOCK");
        setBlockedScriptDropdownNCDEX(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
    if (broker1Details && broker1Details?.length > 0) {
      const updatedFieldsForBroker1 = broker1Details.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));

      setInputFieldsForNCDEXBroker1(updatedFieldsForBroker1);
    }
    if (broker2Details && broker2Details?.length > 0) {
      const updatedFieldsForBroker2 = broker2Details.map((item) => ({
        id: uuidv4(),
        selectedScript: item.script,
        deliveryCom: item.deliveryCom,
        intradayCom: item.intradayCom,
      }));
      setInputFieldsForNCDEXBroker2(updatedFieldsForBroker2);
    }
  }, [
    editDataCustomer,
    editDataCustomer?.marketAccess,
    editDataCustomer?.marketAccess?.ncdexSetting,
  ]);
  // NCDEX ADMIN DATA
  useEffect(() => {
    const brokerageDetails =
    editDataAdmin?.marketAccess?.ncdexSetting?.brokerageDetails;
    const marginDetails =
    editDataAdmin?.marketAccess?.ncdexSetting?.marginDetails || {};
    const otherDetails =
    editDataAdmin?.marketAccess?.ncdexSetting?.otherDetails || {};
    if (brokerageDetails && brokerageDetails?.length > 0) {
      setRadioSelectionNCDEX(brokerageDetails[0]?.type);
      setMinLotBrokeragePerClientNCDEX(
        brokerageDetails[0]?.lot)
        setMinPerBrokeragePerClientNCDEX(
          brokerageDetails[0]?.percent)
      // const updatedFields = brokerageDetails?.map((item) => ({
      //   id: uuidv4(),
      //   selectedScript: item?.script,
      //   deliveryCom: item?.deliveryCom,
      //   intradayCom: item?.intradayCom,
      // }));

      // setInputFieldsNCDEX(updatedFields);
    }
    if (marginDetails) {
      setMaxMarginPerClientNCDEX(marginDetails?.maxMarginPerClient);
      if (marginDetails?.lot === 0 || marginDetails?.lot > 0) {
        setMarginDetailsNCDEXLot(marginDetails?.lot);
        setMarginDetailsRadioSelectionNCDEX("LOT");
        setMarginDetailsDeliveryNCDEX(marginDetails?.lot);
      }
      if (marginDetails?.amount > 0 || marginDetails?.amount === 0) {
        setMarginDetailsNCDEXAmount(marginDetails?.amount);
        setMarginDetailsRadioSelectionNCDEX("AMOUNT");
        setMarginDetailsDeliveryNCDEX(marginDetails?.amount);
      }
    }
    if (otherDetails) {
      setNcdexFreshLimitAllowed(otherDetails?.freshLimit != undefined ? otherDetails?.freshLimit: true);
      setNcdexScriptToWork(otherDetails?.scriptToWork);
      if (
        otherDetails?.allowedScripts &&
        otherDetails?.allowedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNCDEX("ALLOW");
        setScriptDeatailsDropdownNCDEX(
          otherDetails?.allowedScripts
            ? otherDetails?.allowedScripts?.map((option) => option)
            : []
        );
      }
      if (
        otherDetails?.blockedScripts &&
        otherDetails?.blockedScripts?.length > 0
      ) {
        setScriptDetailsRadioSelectionNCDEX("BLOCK");
        setBlockedScriptDropdownNCDEX(
          otherDetails?.blockedScripts
            ? otherDetails?.blockedScripts.map((option) => option)
            : []
        );
      }
    }
  }, [
    editDataAdmin,
    editDataAdmin?.marketAccess,
    editDataAdmin?.marketAccess?.ncdexSetting,
  ]);

  const handleCopySettingDropdownNSEForBrokerageDetails = (selected) => {
    setCopySettingNSEForBrokerageDetails(selected);
  };

  const handleCopySettingDropdownNSEForMarginDetails = (selected) => {
    setCopySettingNSEForMarginDetails(selected);
  };

  const handleCopySettingDropdownMCXorBrokerageDetails = (selected) => {
    setCopySettingMCXForBrokerageDetails(selected);
  };
  const handleCopySettingDropdownMCXForMarginDetails = (selected) => {
    setCopySettingMCXForMarginDetails(selected);
  };
  const handleCopySettingDropdownMCXForOtherDetails = (selected) => {
    setCopySettingMCXForOtherDetails(selected);
  };

  const handleCopySettingDropdownINDEXForBrokerageDetails = (selected) => {
    setCopySettingINDEXForBrokerageDetails(selected);
  };
  const handleCopySettingDropdownINDEXForMarginDetails = (selected) => {
    setCopySettingINDEXForMarginDetails(selected);
  };
  const handleCopySettingDropdownINDEXForOtherDetails = (selected) => {
    setCopySettingINDEXForOtherDetails(selected);
  };

  const handleCopySettingDropdownNCDEXorBrokerageDetails = (selected) => {
    setCopySettingNCDEXForBrokerageDetails(selected);
  };
  const handleCopySettingDropdownNCDEXForMarginDetails = (selected) => {
    setCopySettingNCDEXForMarginDetails(selected);
  };
  const handleCopySettingDropdownNCDEXForOtherDetails = (selected) => {
    setCopySettingNCDEXForOtherDetails(selected);
  };

const handleCopySettingDropdownNSEForQuantitySettings = (selected) => {
    setCopySettingNSEForQuantitySettings(selected); 
    if(selected?.value){
      QuantitySettingsService.getQuantitySettings({"userId" : selected.value, "segment":"NSE"}).then(res => {
            if (res.code === 1) {
              const details = res.data.quantitySettings.quantityDetails;
              if (details.length > 0) {
                 const enrichedDetails = details.map((item, index) => ({
                ...item, // keep existing fields
                id: Date.now() + index, // add id (unique)
              }));
                setQuantitysettingsNSE(enrichedDetails);
              } else{
                setQuantitysettingsNSE([]);
              }
            } 
          });
        } else{
          setQuantitysettingsNSE([]);
        }
  };

  const handleCopySettingDropdownMCXForQuantitySettings = (selected) => {
    setCopySettingMCXForQuantitySettings(selected); 
    if(selected?.value){
      QuantitySettingsService.getQuantitySettings({"userId" : selected.value, "segment":"MCX"}).then(res => {
            if (res.code === 1) {
              const details = res.data.quantitySettings.quantityDetails;
              if (details.length > 0) {
                 const enrichedDetails = details.map((item, index) => ({
                ...item, // keep existing fields
                id: Date.now() + index, // add id (unique)
              }));
                setQuantitysettingsMCX(enrichedDetails);
              } else{
                setQuantitysettingsMCX([]);
              }
            } 
          });
        } else{
          setQuantitysettingsMCX([]);
        }
  };

  const handleCopySettingDropdownGLOBALForQuantitySettings = (selected) => {
    setCopySettingGLOBALForQuantitySettings(selected); 
    if(selected?.value){
      QuantitySettingsService.getQuantitySettings({"userId" : selected.value, "segment":"GLOBAL"}).then(res => {
            if (res.code === 1) {
              const details = res.data.quantitySettings.quantityDetails;
              if (details.length > 0) {
                 const enrichedDetails = details.map((item, index) => ({
                ...item, // keep existing fields
                id: Date.now() + index, // add id (unique)
              }));
                setQuantitysettingsGLOBAL(enrichedDetails);
              } else{
                setQuantitysettingsGLOBAL([]);
              }
            } 
          });
        } else{
          setQuantitysettingsGLOBAL([]);
        }
  };

  useEffect(() => {
    if (!userId) return;

    signupservices
      .updateCustomer({ userId: userId })
      .then((res) => {
        if (res.code === 1 && res.data.USER) {
          const customerData = res.data.USER;
          setEditDataCustomer(res?.data?.USER);
          
        }
      })

      .catch((error) => {
        console.error("Error fetching admin data:", error);
      });
  }, []);

  useEffect(() => {
    if (adminId.segments.includes("NSE")) {
      const nseData = [];
      for (const category in allScripts.NSE) {
          nseData.push({ label: category, value: category });
      }
      setBrokerageScriptsNSE(nseData);
      setScriptDetailsScriptNSE(nseData);
      setBlockedScriptDetailsNSE(nseData);
      setScriptDetailsScript(nseData);


    }

    if (adminId.segments.includes("MCX")) {
      const mcxData = [];
      for (const category in allScripts.MCX) {
        mcxData.push({ label: category, value: category });
      }
      setBrokerageScriptsMCX(mcxData);
      setScriptDetailsScriptMCX(mcxData);
      // setBlockedScriptDetails(mcxData);
      setBlockedScriptDetailsMCX(mcxData);
    }

    if (adminId.segments.includes("GLOBAL")) {
      const globalData = [];
      for (const category in allScripts.GLOBAL) {
        globalData.push({ label: category, value: category });
      }
      setBrokerageScripts(globalData);
      setScriptDetailsScript(globalData);
      setBlockedScriptDetails(globalData);
      setScriptDetailsScript(globalData);
    }
  }, [selectedRole]);

  const doNewAccount = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formObject = Object.fromEntries(formData.entries());

    let accountDetails = {
      partnership: formObject.partnership || "",
      orderHighLow: orderHighLow || formObject.orderHighLow || "false",
      applyAutoSquare: applyAutoSquare || formObject.applyAutoSquare || "false",
      intradaySquare:
        intraDayAutoSquare || formObject.intraDayAutoSquare || "false",
      onlyPositionSquareOff:
        onlyPositionSquareOff || formObject.onlyPositionSquareOff || "false",
      rollOver: rollOver || formObject.rollOver || "false",
      onlyViewAccess: onlyViewAccess || formObject.onlyViewAccess || "false",
      bandScriptAllow: bandScriptAllow || formObject.bandScriptAllow || "false",
      squareOffDisabledInMin: formObject.squareOffDisabledInMin || "",
      alert: formObject.alert || "",
      m2mLoss: formObject.m2mLoss || "",
      orderLimit: formObject.orderLimit || "",
      m2mProfit: formObject.m2mProfit || "",
      ledgerView: ledgerView,
      tradeAllowed: tradeAllowed || formObject.tradeAllowed || "false",
      tradeBlockAbove: formObject.tradeBlockAbove || "",
      tradeBlockBelow: formObject.tradeBlockBelow || "",
      m2mLinkedWithLedger:
        m2mLinkWithLedger || formObject.m2mLinkedWithLedger || "false",
    };
    if (selectedRole !== "CUSTOMER") {
      accountDetails = {
        partnership: accountDetails.partnership,
        onlyPositionSquareOff: accountDetails.onlyPositionSquareOff,
        rollOver: accountDetails.rollOver,
        onlyViewAccess: accountDetails.onlyViewAccess,
        ledgerView: accountDetails.ledgerView,
      };
    } else if (selectedRole === "CUSTOMER") {
      accountDetails = { ...accountDetails };
    }

    let subBrokerInfo = {
      brokerId: selectedBroker1.value,
      brokerPartnership: formObject.selectBrokerPartner || "",
    };
    let subBrokerInfo2 = {
      brokerId: selectedBroker2.value,
      brokerPartnership: formObject.selectBrokerPartner2 || "",
    };

    let marketAccess = {};

    if (isCheckedGlobal) {
      let brokerageDetailsIndex = [];
      if(selectedRole === "CUSTOMER"){
      inputFields.forEach((field) => {
        brokerageDetailsIndex.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
    }else{
      inputFields.forEach((field) => {
        brokerageDetailsIndex.push({
          script: "ALL",
          percent: minPerBrokeragePerClientINDEX || 0,
          lot: null || 0,
        });
      });
    }
      let broker1Data = [];
      inputFieldsForINDEXBroker1.forEach((field) => {
        broker1Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      let broker2Data = [];
      inputFieldsForINDEXBroker2.forEach((field) => {
        broker2Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      if(selectedRole === "CUSTOMER"){
      marketAccess.globalSetting = {
        type: radioSelection,
        brokerageDetails: brokerageDetailsIndex,
        broker1: broker1Data,
        broker2: broker2Data,
        quantityDetails: quantitysettingsGLOBAL,

        marginDetails: {
          lot: marginDetailsINDEXLot,
          amount: marginDetailsINDEXAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientINDEX,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownIndex,
          blockedScripts: blockedScriptDropdownIndex,
          freshLimit: indexFreshLimitAllowed,
          scriptToWork: indexScriptToWork,
        },
      };
    }else{
      marketAccess.globalSetting = {
        type: radioSelection,
        brokerageDetails: brokerageDetailsIndex,
        marginDetails: {
          lot: marginDetailsINDEXLot,
          amount: marginDetailsINDEXAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientINDEX,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownIndex,
          blockedScripts: blockedScriptDropdownIndex,
          freshLimit: indexFreshLimitAllowed,
          scriptToWork: indexScriptToWork,
        },
      };
    }
    }

    if (isCheckedNSE) {
      let brokerageDetailsNSE = [];
      if(selectedRole === "CUSTOMER"){
      inputFieldsNSE.forEach((field) => {
        brokerageDetailsNSE.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
    }else{
      inputFieldsNSE.forEach((field) => {
        brokerageDetailsNSE.push({
          script: "ALL",
          percent: minPerBrokeragePerClientNSE || 0,
          lot: null,
        });
      });
    }
      let broker1Data = [];
      inputFieldsForNSEBroker1.forEach((field) => {
        broker1Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      let broker2Data = [];
      inputFieldsForNSEBroker2.forEach((field) => {
        broker2Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      if(selectedRole === "CUSTOMER"){
      marketAccess.nseSetting = {
        type: radioSelectionNSE,
        brokerageDetails: brokerageDetailsNSE,
        broker1: broker1Data,
        broker2: broker2Data,
        quantityDetails: quantitysettingsNSE,

        marginDetails: {
          lot: marginDetailsNSELot,
          amount: marginDetailsNSEAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientNSE,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownNSE,
          blockedScripts: blockedScriptDropdownNSE,
          freshLimit: nseFreshLimitAllowed,
          scriptToWork: NseScriptToWork,
        },
      };
    }else{
      marketAccess.nseSetting = {
        type: radioSelectionNSE,
        brokerageDetails: brokerageDetailsNSE,
        marginDetails: {
          lot: marginDetailsNSELot,
          amount: marginDetailsNSEAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientNSE,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownNSE,
          blockedScripts: blockedScriptDropdownNSE,
          freshLimit: nseFreshLimitAllowed,
          scriptToWork: NseScriptToWork,
        },
      };
    }
    }

    if (isCheckedMCX) {
      let brokerageDetailsMCX = [];
      if(selectedRole === "CUSTOMER") {
      inputFieldsMCX.forEach((field) => {
        brokerageDetailsMCX.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
    }else{
        const customMCXObjectForRatherThanCustomerType = {
          script: "ALL",
          percent: minPerBrokeragePerClientMCX,
          lot: minLotBrokeragePerClientMCX,
        };
        brokerageDetailsMCX.push(customMCXObjectForRatherThanCustomerType);
        inputFieldsMCXRatherThanCustomerType.forEach((field) => {
          if ((field.id === 1 && !field.selectedScript) || field.selectedScript) {
            brokerageDetailsMCX.push({
              script: field.selectedScript,
              percent: parseFloat(field.mcxPercentage) || 0,
              lot: parseFloat(field.mcxLot) || 0,
            });
          }
        });
    }
      let broker1Data = [];
      inputFieldsForMCXBroker1.forEach((field) => {
        broker1Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      let broker2Data = [];
      inputFieldsForMCXBroker2.forEach((field) => {
        broker2Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      if(selectedRole === "CUSTOMER"){
      marketAccess.mcxSetting = {
        type: radioSelectionMCX,
        brokerageDetails: brokerageDetailsMCX,
        broker1: broker1Data,
        broker2: broker2Data,
        quantityDetails: quantitysettingsMCX,

        marginDetails: {
          lot: marginDetailsMCXLot,
          amount: marginDetailsMCXAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientMCX,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownMCX,
          blockedScripts: blockedScriptDropdownMCX,
          freshLimit: mcxFreshLimitAllowed,
          scriptToWork: mcxScriptToWork,
        },
      };
    }else{
      marketAccess.mcxSetting = {
        type: radioSelectionMCX,
        brokerageDetails: brokerageDetailsMCX,
        marginDetails: {
          lot: marginDetailsMCXLot,
          amount: marginDetailsMCXAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientMCX,
            maxLotPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxLotPerClientMCX,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownMCX,
          blockedScripts: blockedScriptDropdownMCX,
          freshLimit: mcxFreshLimitAllowed,
          scriptToWork: mcxScriptToWork,
        },
      };
    }
    }

    if (isCheckedNCDEX) {
      let brokerageDetailsNCDEX = [];
      if(selectedRole === "CUSTOMER"){
      inputFieldsNCDEX.forEach((field) => {
        brokerageDetailsNCDEX.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
    }else{
      inputFieldsNCDEX.forEach((field) => {
        brokerageDetailsNCDEX.push({
          script: "ALL",
          percent: minPerBrokeragePerClientNCDEX || 0,
          lot: minLotBrokeragePerClientNCDEX || 0,
        });
      });
    }
      let broker1Data = [];
      inputFieldsForNCDEXBroker1.forEach((field) => {
        broker1Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      let broker2Data = [];
      inputFieldsForNCDEXBroker2.forEach((field) => {
        broker2Data.push({
          script: field.selectedScript,
          deliveryCom: parseFloat(field.deliveryCom) || 0,
          intradayCom: parseFloat(field.intradayCom) || 0,
        });
      });
      if(selectedRole === "CUSTOMER"){
      marketAccess.ncdexSetting = {
        type: radioSelectionNCDEX,
        brokerageDetails: brokerageDetailsNCDEX,
        broker1: broker1Data,
        broker2: broker2Data,
        marginDetails: {
          lot: marginDetailsNCDEXLot,
          amount: marginDetailsNCDEXAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientNCDEX,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownNCDEX,
          blockedScripts: blockedScriptDropdownNCDEX,
          freshLimit: ncdexFreshLimitAllowed,
          scriptToWork: ncdexScriptToWork,
        },
      };
    }else{
      marketAccess.ncdexSetting = {
        type: radioSelectionNCDEX,
        brokerageDetails: brokerageDetailsNCDEX,
        marginDetails: {
          lot: marginDetailsNCDEXLot,
          amount: marginDetailsNCDEXAmount,
          maxMarginPerClient:
            selectedRole === "CUSTOMER" ? 0 : maxMarginPerClientNCDEX,
        },
        otherDetails: {
          allowedScripts: scriptDeatailsDropdownNCDEX,
          blockedScripts: blockedScriptDropdownNCDEX,
          freshLimit: ncdexFreshLimitAllowed,
          scriptToWork: ncdexScriptToWork,
        },
      };
    }
    }

    const updatedAdminIdMaster = adminIdMaster || adminId.adminId;

    const jsonData = {
      adminType: selectedRole || "",
      adminId: adminId.adminId,
      firstName: formObject.firstName || "",
      lastName: formObject.lastName || "",
      email: formObject.email || "",
      password: formObject.password || "",
      city: formObject.city || "",
      contactNo: formObject.contactNo || "",
      accountDetails: accountDetails,
      marketAccess: marketAccess,
      remark: formObject.remark,
    };

    if (selectedRole === "CUSTOMER") {
      jsonData.adminId = adminId.adminId;
      jsonData.userId = userId;
      jsonData.subBrokerInfo1 = subBrokerInfo;
      jsonData.subBrokerInfo2 = subBrokerInfo2;

      signupservices
        .updateCustomerData(jsonData)
        .then((resp) => {
          if (resp.code === 0) {
            Swal.fire({
              title: "Error",
              text: resp.messages || "Something went wrong!",
              icon: "error",
            });
          } else {
            Swal.fire({
              title: "Success!",
              text: " Data Updated successfully.",
              icon: "success",
              confirmButtonText: "Okay",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          Swal.fire({
            title: "Error",
            text: "An error occurred while creating the account.",
            icon: "error",
          });
        });
    } else {
      jsonData.adminId = adminIdMaster;
      jsonData.parentAdminId = adminId.adminId;

      signupservices
        .updateAdminData(jsonData)
        .then((resp) => {
          if (resp.code === 0) {
            Swal.fire({
              title: "Error",
              text: resp.messages || "Something went wrong!",
              icon: "error",
            });
          } else {
            Swal.fire({
              title: "Success!",
              text: " Data Updated successfully.",
              icon: "success",
              confirmButtonText: "Okay",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          Swal.fire({
            title: "Error",
            text: "An error occurred while creating the account.",
            icon: "error",
          });
        });
    }
  };

  const handleBrokerageScriptDropdown = (selectedOption, id) => {
    setInputFields((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const inputChangeBrokerageDetails = (e, field, id) => {
    const value = e.target.value;
    setInputFields((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
    ]);
  };

  const handleRemoveField = (id) => {
    setInputFields((prevState) => prevState.filter((item) => item.id !== id));
  };
  const fieldsToRenderINDEX =
    inputFields.length === 0
      ? [
          {
            id: Date.now(),
            selectedScript: "",
            deliveryCom: "",
            intradayCom: "",
          },
        ]
      : inputFields;
  const fieldsToRenderForINDEXBroker1 =
    inputFieldsForINDEXBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForINDEXBroker1;
  const fieldsToRenderForINDEXBroker2 =
    inputFieldsForINDEXBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForINDEXBroker2;

  const fieldsToRenderForNSEBroker1 =
    inputFieldsForNSEBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNSEBroker1;
  const fieldsToRenderForNSEBroker2 =
    inputFieldsForNSEBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNSEBroker2;

  const fieldsToRenderForMCXBroker1 =
    inputFieldsForMCXBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForMCXBroker1;
  const fieldsToRenderForMCXBroker2 =
    inputFieldsForMCXBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForMCXBroker2;

  const fieldsToRenderForNCDEXBroker1 =
    inputFieldsForNCDEXBroker1.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNCDEXBroker1;
  const fieldsToRenderForNCDEXBroker2 =
    inputFieldsForNCDEXBroker2.length === 0
      ? [{ id: 1, selectedScript: "", deliveryCom: "", intradayCom: "" }]
      : inputFieldsForNCDEXBroker2;
  const handleBrokerageScriptDropdownForINDEXBroker1 = (selectedOption, id) => {
    setInputFieldsINDEXForBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForINDEXBroker2 = (selectedOption, id) => {
    setInputFieldsINDEXForBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNSEBroker1 = (selectedOption, id) => {
    setInputFieldsForNSEBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForMCXBroker1 = (selectedOption, id) => {
    setInputFieldsForMCXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForMCXBroker2 = (selectedOption, id) => {
    setInputFieldsForMCXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNCDEXBroker1 = (selectedOption, id) => {
    setInputFieldsForNCDEXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNCDEXBroker2 = (selectedOption, id) => {
    setInputFieldsForNCDEXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownForNSEBroker2 = (selectedOption, id) => {
    setInputFieldsForNSEBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleAddFieldsForINDEXBroker1 = () => {
    setInputFieldsINDEXForBroker1((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForINDEXBroker2 = () => {
    setInputFieldsINDEXForBroker2((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNSEBroker1 = () => {
    setInputFieldsForNSEBroker1((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNSEBroker2 = () => {
    setInputFieldsForNSEBroker2((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForMCXBroker1 = () => {
    setInputFieldsForMCXBroker1((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNCDEXBroker1 = () => {
    setInputFieldsForNCDEXBroker1((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForMCXBroker2 = () => {
    setInputFieldsForMCXBroker2((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };
  const handleAddFieldsForNCDEXBroker2 = () => {
    setInputFieldsForNCDEXBroker2((prevFields) => {
      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", deliveryCom: "", intradayCom: "" },
      ];
    });
  };

  const handleRemoveFieldForINDEXBroker1 = (id) => {
    setInputFieldsINDEXForBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForINDEXBroker2 = (id) => {
    setInputFieldsINDEXForBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

  const handleRemoveFieldForNSEBroker1 = (id) => {
    setInputFieldsForNSEBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForNSEBroker2 = (id) => {
    setInputFieldsForNSEBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForMCXBroker1 = (id) => {
    setInputFieldsForMCXBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForMCXBroker2 = (id) => {
    setInputFieldsForMCXBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForNCDEXBroker1 = (id) => {
    setInputFieldsForNCDEXBroker1((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleRemoveFieldForNCDEXBroker2 = (id) => {
    setInputFieldsForNCDEXBroker2((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const inputChangeBrokerageDetailsINDEXForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsINDEXForBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsINDEXForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsINDEXForBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const inputChangeBrokerageDetailsNSEForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNSEBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsNSEForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNSEBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsMCXForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForMCXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsMCXForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForMCXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsNCDEXForBroker1 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNCDEXBroker1((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const inputChangeBrokerageDetailsNCDEXForBroker2 = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsForNCDEXBroker2((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const handleBrokerageScriptDropdownNSE = (selectedOption, id) => {
    setInputFieldsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const handleQtySettingScriptDropdownNSE = (selectedOption, id) => {
    setQuantitysettingsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              script: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

    const handleQtySettingScriptDropdownMCX = (selectedOption, id) => {
    setQuantitysettingsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              script: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

    const handleQtySettingScriptDropdownGLOBAL = (selectedOption, id) => {
    setQuantitysettingsGLOBAL((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              script: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const fieldsToRender =
    inputFieldsNSE.length === 0
      ? [
          {
            id: Date.now(),
            selectedScript: "",
            deliveryCom: "",
            intradayCom: "",
          },
        ]
      : inputFieldsNSE;

  const inputChangeBrokerageDetailsNSE = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const handleAddFieldsNSE = () => {
    setInputFieldsNSE([
      ...inputFieldsNSE,
      { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
    ]);
  };

  const handleRemoveFieldNSE = (id) => {
    setInputFieldsNSE((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

  const handleBrokerageScriptDropdownMCX = (selectedOption, id) => {
    setInputFieldsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const handleBrokerageScriptDropdownMCXRatherThanCustomerType = (
    selectedOption,
    id
  ) => {
    setInputFieldsMCXRatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };
  const inputChangeBrokerageDetailsForMCXRatherThanCustomerType = (
    e,
    field,
    id
  ) => {
    const value = e.target.value;
    setInputFieldsMCXRatherThanCustomerType((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };
  const handleRemoveFieldMCXRatherThanCustomerType = (id) => {
    setInputFieldsMCXRatherThanCustomerType((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const handleAddFieldsMCXRatherThanCustomerType = () => {
    setInputFieldsMCXRatherThanCustomerType((prevFields) => {

      return [
        ...prevFields,
        { id: uuidv4(), selectedScript: "", mcxPercentage: "", mcxLot: "" },
      ];
    });
  };
  const inputChangeBrokerageDetailsMCX = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const inputChangeQtySettingsNSE = (e, field, id) => {
    const value = e.target ? e.target.value : e.value;

    setQuantitysettingsNSE((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const inputChangeQtySettingsMCX = (e, field, id) => {
    const value = e.target ? e.target.value : e.value;

    setQuantitysettingsMCX((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const inputChangeQtySettingsGLOBAL = (e, field, id) => {
    const value = e.target ? e.target.value : e.value;

    setQuantitysettingsGLOBAL((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

   const handleAddFieldsNSEQtySettings = () => {
    setQuantitysettingsNSE([
        ...quantitysettingsNSE,
        { id: Date.now(), segment: "NSE", script:"", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null }
    ]);
  };

    const handleAddFieldsMCXQtySettings = () => {
    setQuantitysettingsMCX([
        ...quantitysettingsMCX,
        { id: Date.now(), segment: "MCX", script:"", type:"LOT", minOrder: null, maxOrder: null, positionLimit: null }
    ]);
  };

    const handleAddFieldsGLOBALQtySettings = () => {
    setQuantitysettingsGLOBAL([
        ...quantitysettingsGLOBAL,
        { id: Date.now(), segment: "GLOBAL", script:"", type:"QTY", minOrder: null, maxOrder: null, positionLimit: null }
    ]);
  };

  const handleAddFieldsMCX = () => {
    setInputFieldsMCX([
      ...inputFieldsMCX,
      { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
    ]);
  };

   const handleRemoveFieldQtyNSE = (id) => {
    setQuantitysettingsNSE((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

  const handleRemoveFieldQtyMCX = (id) => {
    setQuantitysettingsMCX((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

  const handleRemoveFieldQtyGLOBAL = (id) => {
    setQuantitysettingsGLOBAL((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };

  const handleRemoveFieldMCX = (id) => {
    setInputFieldsMCX((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const fieldsToRenderMCX =
    inputFieldsMCX.length === 0
      ? [
          {
            id: Date.now(),
            selectedScript: "",
            deliveryCom: "",
            intradayCom: "",
          },
        ]
      : inputFieldsMCX;

  const fieldsToRenderQtySettingsNSE =
    quantitysettingsNSE.length === 0
      ? [{ id: 1, segment: "NSE", script: "ALL", type:"QTY", minOrder: 0, maxOrder: 0, positionLimit: 0 }]
      : quantitysettingsNSE;

  const fieldsToRenderQtySettingsMCX =
    quantitysettingsMCX.length === 0
      ? [{ id: 1, segment: "MCX", script: "ALL", type:"LOT", minOrder: 0, maxOrder: 0, positionLimit: 0 }]
      : quantitysettingsMCX;
  
  const fieldsToRenderQtySettingsGLOBAL =
    quantitysettingsGLOBAL.length === 0
      ? [{ id: 1, segment: "GLOBAL", script: "ALL", type:"QTY", minOrder: 0, maxOrder: 0, positionLimit: 0 }]
      : quantitysettingsGLOBAL;

  const handleBrokerageScriptDropdownNCDEX = (selectedOption, id) => {
    setInputFieldsNCDEX((prevState) =>
      prevState.map((item) =>
        item.id === id
          ? {
              ...item,
              selectedScript: selectedOption ? selectedOption.value : "",
            }
          : item
      )
    );
  };

  const inputChangeBrokerageDetailsNCDEX = (e, field, id) => {
    const value = e.target.value;
    setInputFieldsNCDEX((prevState) =>
      prevState.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const handleAddFieldsNCDEX = () => {
    setInputFieldsNCDEX([
      ...inputFieldsNCDEX,
      { id: Date.now(), selectedScript: "", deliveryCom: "", intradayCom: "" },
    ]);
  };

  const handleRemoveFieldNCDEX = (id) => {
    setInputFieldsNCDEX((prevState) =>
      prevState.filter((item) => item.id !== id)
    );
  };
  const fieldsToRenderNCDEX =
    inputFieldsNCDEX.length === 0
      ? [
          {
            id: Date.now(),
            selectedScript: "",
            deliveryCom: "",
            intradayCom: "",
          },
        ]
      : inputFieldsNCDEX;

  const handleCopySettingDropdown = (selected) => {
    setSelectedOption(selected);
  };
  const handleSubBrokerDropdown = (selectedOption) => {
    setSelectedBroker1(selectedOption);
  };
  const handleSubBroker2Dropdown = (selectedOption) => {
    setSelectedBroker2(selectedOption);
  };
  const handleScriptDetailsDropdown = (selectedOptions) => {
    setScriptDeatailsDropdown(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdown = (selectedOptions) => {
    setBlockedScriptDropdown(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelection = (selection) => {
    setMarginDetailsRadioSelection(selection);
    if (selection === "LOT") {
      setMarginDetails({ lot: marginDetailsDelivery, amount: null });
    } else if (selection === "AMOUNT") {
      setMarginDetails({ lot: null, amount: marginDetailsDelivery });
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setMarginDetailsDelivery(value);

    if (marginDetailsRadioSelection === "LOT") {
      setMarginDetails({ lot: value, amount: null });
    } else if (marginDetailsRadioSelection === "AMOUNT") {
      setMarginDetails({ lot: null, amount: value });
    }
  };
  const handleBrokerageScriptDropdwonMCX = (selectedOption) => {
    if (Array.isArray(selectedOption)) {
      setBrokerageDropdownMCX(selectedOption.map((option) => option.value));
    } else {
      setBrokerageDropdownMCX(selectedOption ? [selectedOption.value] : []);
    }
  };
  const handleCopySettingDropdownMCX = (selected) => {
    setSelectedOptionMCX(selected);
  };

  const handleScriptDetailsDropdownMCX = (selectedOptions) => {
    setScriptDeatailsDropdownMCX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownMCX = (selectedOptions) => {
    setBlockedScriptDropdownMCX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelectionMCX = (selection) => {
    setMarginDetailsRadioSelectionMCX(selection);
    if (selection === "LOT") {
      setMarginDetailsMCX({ lot: marginDetailsDeliveryMCX, amount: null });
    } else if (selection === "AMOUNT") {
      setMarginDetailsMCX({ lot: null, amount: marginDetailsDeliveryMCX });
    }
  };

  const handleInputChangeMCX = (e) => {
    const value = e.target.value;
    setMarginDetailsDeliveryMCX(value);

    if (marginDetailsRadioSelectionMCX === "LOT") {
      setMarginDetailsMCX({ lot: value, amount: null });
    } else if (marginDetailsRadioSelection === "AMOUNT") {
      setMarginDetailsMCX({ lot: null, amount: value });
    }
  };

  const handleBrokerageScriptDropdwonNSE = (selectedOption) => {
    if (Array.isArray(selectedOption)) {
      setBrokerageDropdownNSE(selectedOption.map((option) => option.value));
    } else {
      setBrokerageDropdownNSE(selectedOption ? [selectedOption.value] : []);
    }
  };
  const handleCopySettingDropdownNSE = (selected) => {
    setSelectedOptionNSE(selected);
  };

  const handleScriptDetailsDropdownNSE = (selectedOptions) => {
    setScriptDeatailsDropdownNSE(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownNSE = (selectedOptions) => {
    setBlockedScriptDropdownNSE(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelectionNSE = (selection) => {
    setMarginDetailsRadioSelectionNSE(selection);
    if (selection === "LOT") {
      setMarginDetailsNSE({ lot: marginDetailsDeliveryNSE, amount: null });
    } else if (selection === "AMOUNT") {
      setMarginDetailsNSE({ lot: null, amount: marginDetailsDeliveryNSE });
    }
  };

  const handleInputChangeNSE = (e) => {
    const value = e.target.value;
    setMarginDetailsDeliveryNSE(value);

    if (marginDetailsRadioSelectionNSE === "LOT") {
      setMarginDetailsNSE({ lot: value, amount: null });
    } else if (marginDetailsRadioSelectionNSE === "AMOUNT") {
      setMarginDetailsNSE({ lot: null, amount: value });
    }
  };

  const handleBrokerageScriptDropdwonNCDEX = (selectedOption) => {
    if (Array.isArray(selectedOption)) {
      setBrokerageDropdownNCDEX(selectedOption.map((option) => option.value));
    } else {
      setBrokerageDropdownNCDEX(selectedOption ? [selectedOption.value] : []);
    }
  };
  const handleCopySettingDropdownNCDEX = (selected) => {
    setSelectedOptionNCDEX(selected);
  };

  const handleScriptDetailsDropdownNCDEX = (selectedOptions) => {
    setScriptDeatailsDropdownNCDEX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };

  const handleBlockedScriptDropdownNCDEX = (selectedOptions) => {
    setBlockedScriptDropdownNCDEX(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
  };
  const handleRadioSelectionNCDEX = (selection) => {
    setMarginDetailsRadioSelectionNCDEX(selection);
    if (selection === "LOT") {
      setMarginDetailsNCDEX({ lot: marginDetailsDeliveryNCDEX, amount: null });
    } else if (selection === "AMOUNT") {
      setMarginDetailsNCDEX({ lot: null, amount: marginDetailsDeliveryNCDEX });
    }
  };

  const handleInputChangeNCDEX = (e) => {
    const value = e.target.value;
    setMarginDetailsDeliveryNCDEX(value);

    if (marginDetailsRadioSelectionNCDEX === "LOT") {
      setMarginDetailsNCDEX({ lot: value, amount: null });
    } else if (marginDetailsRadioSelectionNCDEX === "AMOUNT") {
      setMarginDetailsNCDEX({ lot: null, amount: value });
    }
  };

  return (
    <div className="container-fluid pb-5">
      <Form onSubmit={(e) => doNewAccount(e)} id="signup-form">
        <input type="hidden" name="parentAdminId" value={adminIdMaster} />
        <input type="hidden" name="adminId" value={adminIdMaster} />
        <div>
          <Card className="mt-2">
            <Card.Body>
              <Row>
                <lagend className="fieldset-legend-title label-color">
                  BASIC DETAILS
                </lagend>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} xs={6} sm={3} controlId="formAdminType">
                  <Form.Label>
                    <b className="fss-875 label-color">ACCOUNT TYPE</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="adminType"
                    className="form-control bg-white text-black"
                    size="sm"
                    value={selectedRole}
                    readOnly
                  />
                </Form.Group>
                <Form.Group as={Col} xs={6} sm={3} controlId="formAdminType">
                  <Form.Label>
                    <b className="fss-875 label-color">USER NAME</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="adminType"
                    className="form-control bg-white text-black"
                    size="sm"
                    value={userName}
                    readOnly
                  />
                </Form.Group>

                <Form.Group
                  as={Col}
                  xs={6}
                  sm={3}
                  controlId="formBasicfirstName"
                >
                  <Form.Label style={{ display: "flex", alignItems: "center" }}>
                    {" "}
                    <b className="fss-875 label-color mt-1">
                      ACCOUNT NAME
                      <b style={{ fontSize: "0.9rem", color: "red" }}>*</b>
                    </b>
                  </Form.Label>
                  <Form.Control
                    className="bg-white text-black custom-placeholder"
                    type="text"
                    size="sm"
                    placeholder="First name"
                    id="firstName"
                    name="firstName"
                    required
                    value={formData.firstName}
                    onChange={handleChange}
                    onBlur={(e) => validateField(e.target.name, e.target.value)}
                    isInvalid={!!errors.firstName}
                    minLength={4}
                    maxLength={20}
                    title="FirstName must be between 4 to 20 characters."
                  />
                </Form.Group>
              
              </Row>
              <Row>
                <Col
                  sm={3}
                  xl={4}
                  xs={12}
                  className={`fss-875 label-color mb-1`}
                >
                  LEDGER VIEW
                  <Form>
                    {["radio"].map((type) => (
                      <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                          className="custom-radio"
                          inline
                          label="YES"
                          name="ledgerView"
                          value="YES"
                          type={type}
                          id={`inline-${type}-1`}
                          checked={ledgerView === true}
                          onChange={() => handleRadioChange(true)}
                        />
                        <Form.Check
                          className="custom-radio"
                          inline
                          label="NO"
                          name="ledgerView"
                          value="NO"
                          type={type}
                          id={`inline-${type}-2`}
                          checked={ledgerView === false}
                          onChange={() => handleRadioChange(false)}
                        />
                      </div>
                    ))}
                  </Form>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
        {selectedRole !== "" && selectedRole !== "SELECT ROLE" && (
          <div>
            {selectedRole !== "SUBBROKER" && (
              <>
                <div id="customerAccountDetails">
                  <Card className="mt-1 pt-0">
                    <Card.Body className="pt-1">
                      <Row>
                        <lagend className="fieldset-legend-title label-color">
                          ACCOUNT DETAILS
                        </lagend>
                      </Row>
                      <div>
                        {selectedRole !== "CUSTOMER" && (
                          <>
                            <Row className="mt-2">
                              <Col sm={3}>
                                <b style={{ fontSize: 13 }}>
                                  PARTNERSHIP(%)
                                  <b
                                    style={{ fontSize: "0.9rem", color: "red" }}
                                  >
                                    *
                                  </b>{" "}
                                </b>
                              </Col>
                              <Col sm={2}>
                                <InputGroup size="sm" className="mb-3">
                                  <Form.Control
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white text-black custom-placeholder"
                                    placeholder="partnership(%)"
                                    name="partnership"
                                    type="number"
                                    required
                                    value={formData.partnership}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (
                                        parseFloat(value) < 1 &&
                                        value !== ""
                                      ) {
                                        return;
                                      }

                                      handleChange(e);
                                    }}
                                    onBlur={(e) => {
                                      validateField(
                                        e.target.name,
                                        e.target.value
                                      );

                                      if (parseFloat(e.target.value) < 1) {
                                        setErrors((prevErrors) => ({
                                          ...prevErrors,
                                          partnership:
                                            "Partnership must be greater than or equal to 1",
                                        }));
                                      }
                                    }}
                                    isInvalid={!!errors.partnership}
                                  />
                                </InputGroup>
                              </Col>
                              <Col sm={1}></Col>
                            </Row>
                          </>
                        )}
                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="mt-1">
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>ORDER BETWEEN HIGH LOW </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-1 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        label="YES"
                                        name="orderHighLow"
                                        value="YES"
                                        type={type}
                                        inline
                                        checked={orderHighLow === true}
                                        onChange={() => setOrderHighLow(true)}
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        type={type}
                                        label="NO"
                                        name="orderHighLow"
                                        value="NO"
                                        inline
                                        checked={orderHighLow === false}
                                        onChange={() => setOrderHighLow(false)}
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color mt-2"
                              >
                                <b>APPLY AUTO SQUARE </b>
                              </Col>
                              <Col sm={3} xs={5} className="mt-2">
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-1 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="YES"
                                        name="autoSquare"
                                        value="YES"
                                        type={type}
                                        checked={applyAutoSquare === true}
                                        onChange={() => setAutoSquare(true)}
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="autoSquare"
                                        value="NO"
                                        type={type}
                                        checked={applyAutoSquare === false}
                                        onChange={() => setAutoSquare(false)}
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                            </Row>
                          </>
                        )}
                        <Row>
                          {selectedRole === "CUSTOMER" && (
                            <>
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>INTRA DAY AUTO SQUARE </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-4 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        type={type}
                                        id={`inline-${type}-1`}
                                        label="YES"
                                        name="intraDayAutoSquare"
                                        value="YES"
                                        inline
                                        checked={intraDayAutoSquare === true}
                                        onChange={() =>
                                          setIntraDayAutoSquare(true)
                                        }
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        type={type}
                                        label="NO"
                                        name="intraDayAutoSquare"
                                        value="NO"
                                        id={`inline-${type}-2`}
                                        inline
                                        checked={intraDayAutoSquare === false}
                                        onChange={() =>
                                          setIntraDayAutoSquare(false)
                                        }
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                            </>
                          )}
                          <Col sm={3} xs={7} className="fss-875 label-color">
                            <b>ONLY POSITION SQUAREOFF</b>
                          </Col>
                          <Col sm={3} xs={5}>
                            <Form>
                              {["radio"].map((type) => (
                                <div
                                  key={`inline-${type}`}
                                  className={
                                    isMobile
                                      ? "mb-3 ps-0 pe-0 text-right"
                                      : "ms-4 mb-3"
                                  }
                                >
                                  <Form.Check
                                    className="custom-radio ps-0 pe-0 label-color fss-875"
                                    type={type}
                                    id={`inline-${type}-1`}
                                    label="YES"
                                    name="onlyPositionSquare"
                                    value="YES"
                                    inline
                                    checked={onlyPositionSquareOff === true}
                                    onChange={() => setOnlyPositionSquare(true)}
                                  />
                                  <Form.Check
                                    className="custom-radio label-color fss-875"
                                    type={type}
                                    label="NO"
                                    name="onlyPositionSquare"
                                    value="NO"
                                    id={`inline-${type}-2`}
                                    inline
                                    checked={onlyPositionSquareOff === false}
                                    onChange={() =>
                                      setOnlyPositionSquare(false)
                                    }
                                  />
                                </div>
                              ))}
                            </Form>
                          </Col>
                        </Row>
                        <Row className="mt-1">
                          <Col sm={3} xs={7} className="fss-875 label-color">
                            <b>ROLL OVER </b>
                          </Col>
                          <Col sm={3} xs={5}>
                            <Form>
                              {["radio"].map((type) => (
                                <div
                                  key={`inline-${type}`}
                                  className={
                                    isMobile
                                      ? "mb-3 ps-0 pe-0 text-right"
                                      : "ms-4 mb-3"
                                  }
                                >
                                  <Form.Check
                                    className="custom-radio ps-0 pe-0 label-color fss-875"
                                    inline
                                    label="YES"
                                    name="rollOver"
                                    value="YES"
                                    type={type}
                                    id={`inline-${type}-1`}
                                    checked={rollOver === true}
                                    onChange={() => setRollOver(true)}
                                  />
                                  <Form.Check
                                    className="custom-radio label-color fss-875"
                                    inline
                                    label="NO"
                                    name="rollOver"
                                    value="NO"
                                    type={type}
                                    id={`inline-${type}-2`}
                                    checked={rollOver === false}
                                    onChange={() => setRollOver(false)}
                                  />
                                </div>
                              ))}
                            </Form>
                          </Col>
                          <Col sm={3} xs={7} className="fss-875 label-color">
                            <b>ONLY VIEW ACCESS </b>
                          </Col>
                          <Col sm={3} xs={5}>
                            <Form>
                              {["radio"].map((type) => (
                                <div
                                  key={`inline-${type}`}
                                  className={
                                    isMobile
                                      ? "mb-3 ps-0 pe-0 text-right"
                                      : "ms-4 mb-3"
                                  }
                                >
                                  <Form.Check
                                    className="custom-radio ps-0 pe-0 label-color fss-875"
                                    inline
                                    label="YES"
                                    name="onlyViewAccess"
                                    value="YES"
                                    type={type}
                                    id={`inline-${type}-1`}
                                    checked={onlyViewAccess === true}
                                    onChange={() => setOnlyViewAccess(true)}
                                  />
                                  <Form.Check
                                    className="custom-radio label-color fss-875"
                                    inline
                                    label="NO"
                                    name="onlyViewAccess"
                                    value="NO"
                                    type={type}
                                    id={`inline-${type}-2`}
                                    checked={onlyViewAccess === false}
                                    onChange={() => setOnlyViewAccess(false)}
                                  />
                                </div>
                              ))}
                            </Form>
                          </Col>
                        </Row>
                        <Row className="mt-1">
                          {selectedRole === "CUSTOMER" && (
                            <>
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>BAND SCRIPT ALLOW </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-3 ps-0 pe-0 text-right"
                                          : "ms-4 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        inline
                                        label="YES"
                                        name="bandScripAllow"
                                        value="YES"
                                        type={type}
                                        id={`inline-${type}-1`}
                                        checked={bandScriptAllow === true}
                                        onChange={() =>
                                          setBandScriptAllow(true)
                                        }
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="bandScripAllow"
                                        value="NO"
                                        type={type}
                                        id={`inline-${type}-2`}
                                        checked={bandScriptAllow === false}
                                        onChange={() =>
                                          setBandScriptAllow(false)
                                        }
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                            </>
                          )}

                          {selectedRole === "CUSTOMER" && (
                            <>
                              <Col
                                sm={3}
                                xs={7}
                                className="fss-875 label-color"
                              >
                                <b>M2M LINKED WITH LEDGER </b>
                              </Col>
                              <Col sm={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mb-1 ps-0 pe-0 text-right"
                                          : "ms-4 mb-3"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        inline
                                        label="YES"
                                        name="m2mLinkedWithLedger"
                                        value="YES"
                                        type={type}
                                        checked={m2mLinkWithLedger === true}
                                        onChange={() =>
                                          setm2mLinkWithLedger(true)
                                        }
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="m2mLinkedWithLedger"
                                        value="NO"
                                        type={type}
                                        checked={m2mLinkWithLedger === false}
                                        onChange={() =>
                                          setm2mLinkWithLedger(false)
                                        }
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                            </>
                          )}
                        </Row>

                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="mt-1">
                              <Col
                                sm={3}
                                xl={3}
                                xs={7}
                                className={
                                  isMobile
                                    ? "fss-875 label-color pt-1"
                                    : "fss-875 label-color"
                                }
                              >
                                <b>TRADE ALLOWED </b>
                              </Col>
                              <Col sm={3} xl={3} xs={5}>
                                <Form>
                                  {["radio"].map((type) => (
                                    <div
                                      key={`inline-${type}`}
                                      className={
                                        isMobile
                                          ? "mt-1 mb-3 ps-0 pe-0 text-right"
                                          : "ms-4 mb-1"
                                      }
                                    >
                                      <Form.Check
                                        className="custom-radio ps-0 pe-0 label-color fss-875"
                                        inline
                                        label="YES"
                                        name="tradeAllowed"
                                        value="YES"
                                        type={type}
                                        id={`inline-${type}-1`}
                                        checked={tradeAllowed === true}
                                        onChange={() => setTradeAllowed(true)}
                                      />
                                      <Form.Check
                                        className="custom-radio label-color fss-875"
                                        inline
                                        label="NO"
                                        name="tradeAllowed"
                                        value="NO"
                                        type={type}
                                        id={`inline-${type}-2`}
                                        checked={tradeAllowed === false}
                                        onChange={() => setTradeAllowed(false)}
                                      />
                                    </div>
                                  ))}
                                </Form>
                              </Col>
                              <Col
                                sm={3}
                                xl={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>ALERT (%) </b>
                              </Col>
                              <Col sm={2} xl={2} xs={6}>
                                <InputGroup size="sm">
                                  <Form.Control
                                    type="number"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white custom-placeholder value-color"
                                    placeholder="ALERT(%)"
                                    name="alert"
                                    value={formData.alert}
                                    onChange={handleChange}
                                  />
                                </InputGroup>
                              </Col>
                            </Row>
                          </>
                        )}
                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="pt-1 mt-1">
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>ORDER LIMIT (%)</b>
                              </Col>
                              <Col sm={2} xs={6}>
                                <InputGroup size="sm">
                                  <Form.Control
                                    aria-label="Small"
                                    type="number"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  custom-placeholder  value-color "
                                    placeholder="OrderLimit(%)"
                                    name="orderLimit"
                                    value={formData.orderLimit}
                                    onChange={handleChange}
                                  />
                                </InputGroup>
                              </Col>
                              <Col sm={1}></Col>

                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>SQ. OFF DISABLED IN (MINUTES) </b>
                              </Col>
                              <Col sm={2} xs={6} className="mt-1">
                                <InputGroup size="sm">
                                  <Form.Control
                                    type="number"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="0"
                                    name="squareOffDisabledInMin"
                                    value={formData.squareOffDisabledInMin}
                                    onChange={handleChange}
                                  />
                                </InputGroup>
                              </Col>
                              <Col sm={1}></Col>
                            </Row>
                            <Row className="mt-2">
                              <Col
                                sm={3}
                                xl={3}
                                xs={6}
                                className="fss-875 label-color mt-1"
                              >
                                <b>M2M LOSS </b>
                              </Col>
                              <Col
                                sm={2}
                                xl={2}
                                xs={6}
                                className={!isMobile ? "mt-0" : "mt-1"}
                              >
                                <InputGroup size="sm">
                                  <Form.Control
                                    type="number"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-xl"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="M2M LOSS"
                                    name="m2mLoss"
                                    value={formData.m2mLoss}
                                    onChange={handleChange}
                                  />
                                </InputGroup>
                                {formData.m2mLoss ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.m2mLoss, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                              <Col sm={1}></Col>
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color mt-1"
                              >
                                <b>M2M PROFIT </b>
                              </Col>
                              <Col sm={2} xs={6} className="mt-1">
                                <InputGroup size="sm ">
                                  <Form.Control
                                    aria-label="Small"
                                    type="number"
                                    aria-describedby="inputGroup-sizing-xl"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="M2M PROFIT"
                                    name="m2mProfit"
                                    value={formData.m2mProfit}
                                    onChange={handleChange}
                                  />
                                </InputGroup>
                                {formData.m2mProfit ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.m2mProfit, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                              <Col sm={1}></Col>
                            </Row>
                          </>
                        )}
                        {selectedRole === "CUSTOMER" && (
                          <>
                            <Row className="mt-1">
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color"
                              >
                                <b>TRADE BLOCK ABOVE </b>
                              </Col>
                              <Col sm={2} xs={6}>
                                <InputGroup size="sm">
                                  <Form.Control
                                    type="number"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white  value-color custom-placeholder"
                                    placeholder="Trade Block Above"
                                    name="tradeBlockAbove"
                                    value={formData.tradeBlockAbove}
                                    onChange={handleChange}
                                  />
                                </InputGroup>
                                {formData.tradeBlockAbove ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.tradeBlockAbove, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                              <Col sm={1}></Col>
                              <Col
                                sm={3}
                                xs={6}
                                className="fss-875 label-color mt-1"
                              >
                                <b>TRADE BLOCK BELOW </b>
                              </Col>
                              <Col sm={2} xs={6} className="mt-1">
                                <InputGroup size="sm">
                                  <Form.Control
                                    type="number"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                    className="bg-white value-color custom-placeholder"
                                    placeholder="Trade Block Below"
                                    name="tradeBlockBelow"
                                    value={formData.tradeBlockBelow}
                                    onChange={handleChange}
                                  />
                                </InputGroup>
                                {formData.tradeBlockBelow ? (
                                  <label className="word-color">
                                    {" "}
                                    {NumberToWordFormatter.numberToWordsIndian(
                                      parseInt(formData.tradeBlockBelow, 10)
                                    )}{" "}
                                  </label>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                          </>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </div>

                <div id="customerdetails">
                  <Row className="mt-2">
                    <Col xs={12} xl={4}>
                      <Card>
                        <Card.Body className="pt-0">
                          <div>
                            <Row>
                              <lagend className="fieldset-legend-title label-color">
                                MARKET ACCESS
                              </lagend>
                            </Row>
                            <Row className="mt-1"></Row>
                            <Row>
                              {adminId.segments.includes("GLOBAL") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 1"
                                      type="checkbox"
                                      label="GLOBAL"
                                      className="custom-checkbox label-color fss-875"
                                      checked={isCheckedGlobal}
                                      onChange={handleCheckboxChange}
                                      name="index"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedGlobal}
                                      onClick={handleOpenModal}
                                    >
                                      <b>
                                        GLOBAL <br /> Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                              {adminId.segments.includes("NSE") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 2"
                                      type="checkbox"
                                      label="NSE"
                                      className="custom-checkbox label-color fss-875"
                                      checked={isCheckedNSE}
                                      onChange={handleCheckboxChange}
                                      name="nse"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedNSE}
                                      onClick={handleOpenModalNSE}
                                    >
                                      <b>
                                        NSE <br />
                                        Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}

                              {adminId.segments.includes("MCX") ? (
                                <>
                                  <Col>
                                    <Form.Check
                                      aria-label="option 3"
                                      type="checkbox"
                                      label="MCX"
                                      className="custom-checkbox label-color fss-875"
                                      checked={isCheckedMCX}
                                      onChange={handleCheckboxChange}
                                      name="mcx"
                                    />
                                    <Button
                                      size="sm"
                                      variant="success"
                                      className="fss-07 w-auto market-access"
                                      disabled={!isCheckedMCX}
                                      onClick={handleOpenModalMCX}
                                    >
                                      <b>
                                        MCX <br />
                                        Setting
                                      </b>
                                    </Button>
                                  </Col>
                                </>
                              ) : null}
                             
                              <Modal
                                show={showModal}
                                onHide={handleCloseModal}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    GLOBAL
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col xl={5} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          {selectedRole === "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -10 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="group1"
                                                        type={type}
                                                        checked={
                                                          radioSelection ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelection(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="group1"
                                                        type={type}
                                                        checked={
                                                          radioSelection ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelection(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>
                                              <div>
                                                {fieldsToRenderINDEX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScripts
                                                          }
                                                          value={
                                                            brokerageScripts.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOption
                                                          ) =>
                                                            handleBrokerageScriptDropdown(
                                                              selectedOption,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black text-nowrap"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetails(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetails(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputFields.length >
                                                              1 &&
                                                              inputFields.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.id !==
                                                                    1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveField(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}

                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFields
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                {selectedBroker1 &&
                                                  selectedBroker1?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker1?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForINDEXBroker1.map(
                                                        (inputField, index) => (
                                                          <>
                                                            <Row
                                                              data-id={
                                                                inputField.id
                                                              }
                                                              className="mb-3"
                                                            >
                                                              <Col
                                                                xs={4}
                                                                className={`${
                                                                  isMobile
                                                                    ? "ps-1"
                                                                    : ""
                                                                }`}
                                                              >
                                                                <Form.Label
                                                                  className={`fss-875 label-color mb-1 text-nowrap ${
                                                                    !isMobile
                                                                      ? "mt-3"
                                                                      : "mt-3"
                                                                  }`}
                                                                >
                                                                  SELECT SCRIPT
                                                                </Form.Label>
                                                                <Select
                                                                  options={
                                                                    brokerageScripts
                                                                  }
                                                                  value={
                                                                    brokerageScripts.find(
                                                                      (
                                                                        script
                                                                      ) =>
                                                                        script.value ===
                                                                        inputField.selectedScript
                                                                    ) || null
                                                                  }
                                                                  onChange={(
                                                                    selectedOption
                                                                  ) =>
                                                                    handleBrokerageScriptDropdownForINDEXBroker1(
                                                                      selectedOption,
                                                                      inputField.id
                                                                    )
                                                                  }
                                                                  getOptionLabel={(
                                                                    e
                                                                  ) => e.label}
                                                                  placeholder={
                                                                    index === 0
                                                                      ? "All"
                                                                      : "Select"
                                                                  }
                                                                  isSearchable={
                                                                    false
                                                                  }
                                                                  className="fss-01 small-select text-black ps-0"
                                                                  theme={the}
                                                                  isDisabled={
                                                                    index === 0
                                                                  }
                                                                  styles={
                                                                    customStyles
                                                                  }
                                                                />
                                                              </Col>
                                                              <Col
                                                                xs={4}
                                                                className={`${
                                                                  isMobile
                                                                    ? "ps-1"
                                                                    : ""
                                                                }`}
                                                              >
                                                                <Form.Label
                                                                  className={`fss-875 label-color mb-1 text-nowrap ${
                                                                    !isMobile
                                                                      ? "mt-3"
                                                                      : "mt-3"
                                                                  }`}
                                                                >
                                                                  {" "}
                                                                  DELIVERY COM
                                                                </Form.Label>
                                                                <input
                                                                  type="number"
                                                                  className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                  placeholder="Delivery"
                                                                  name="deliveryCom"
                                                                  value={
                                                                    inputField.deliveryCom
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    inputChangeBrokerageDetailsINDEXForBroker1(
                                                                      e,
                                                                      "deliveryCom",
                                                                      inputField.id
                                                                    )
                                                                  }
                                                                />
                                                              </Col>
                                                              <Col
                                                                xs={4}
                                                                className={`${
                                                                  isMobile
                                                                    ? "ps-1"
                                                                    : ""
                                                                }`}
                                                              >
                                                                <Row>
                                                                  <Col xs={11}>
                                                                    <Form.Label
                                                                      className={`fss-875 label-color mb-1 text-nowrap ${
                                                                        !isMobile
                                                                          ? "mt-3"
                                                                          : "mt-3"
                                                                      }`}
                                                                    >
                                                                      {" "}
                                                                      INTRADAY
                                                                      COM
                                                                    </Form.Label>
                                                                  </Col>
                                                                </Row>
                                                                <Row>
                                                                  <Col
                                                                    xs={12}
                                                                    className="d-flex"
                                                                    style={{
                                                                      display:
                                                                        "inline-block",
                                                                    }}
                                                                  >
                                                                    <input
                                                                      type="number"
                                                                      className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                      placeholder="Intraday"
                                                                      name="intradayCom"
                                                                      value={
                                                                        inputField.intradayCom
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        inputChangeBrokerageDetailsINDEXForBroker1(
                                                                          e,
                                                                          "intradayCom",
                                                                          inputField.id
                                                                        )
                                                                      }
                                                                    />

                                                                    {inputField.id ===
                                                                    1 ? (
                                                                      <Col
                                                                        sm={1}
                                                                        data-id={
                                                                          inputField.id
                                                                        }
                                                                        className="d-flex mt-3 justify-content-center align-items-center "
                                                                      >
                                                                        {" "}
                                                                      </Col>
                                                                    ) : (
                                                                      ""
                                                                    )}
                                                                    {inputFieldsForINDEXBroker1.map(
                                                                      (field) =>
                                                                        inputField.id ===
                                                                          field.id &&
                                                                        inputField.id !==
                                                                          1 ? (
                                                                          <span
                                                                            className="text-danger cursor-pointer"
                                                                            style={{
                                                                              fontSize:
                                                                                "20px",
                                                                              fontWeight:
                                                                                "800",
                                                                            }}
                                                                            onClick={() =>
                                                                              handleRemoveFieldForINDEXBroker1(
                                                                                inputField.id
                                                                              )
                                                                            }
                                                                          >
                                                                            ×
                                                                          </span>
                                                                        ) : null
                                                                    )}
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                            </Row>
                                                          </>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForINDEXBroker1
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                                {selectedBroker2 &&
                                                  selectedBroker2?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker2?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForINDEXBroker2.map(
                                                        (inputField, index) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScripts
                                                                }
                                                                value={
                                                                  brokerageScripts.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForINDEXBroker2(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  index === 0
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  index === 0
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsINDEXForBroker2(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsINDEXForBroker2(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForINDEXBroker2.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForINDEXBroker2(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForINDEXBroker2
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-2" : ""
                                                    }`}
                                                  >
                                                    MIN % WISE BROKERAGE PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minPerBrokeragePerClientINDEX"
                                                    value={
                                                      minPerBrokeragePerClientINDEX
                                                    }
                                                    // onChange={handleInputChange}
                                                    onChange={(e) => {
                                                      setMinPerBrokeragePerClientINDEX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minPerBrokeragePerClientINDEX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minPerBrokeragePerClientINDEX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            </>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={3} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group3"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelection ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelection(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group3"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelection ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelection(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelection ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryINDEX"
                                                  value={marginDetailsINDEXLot}
                                                  // onChange={handleInputChange}
                                                  onChange={(e) => {
                                                    setMarginDetailsINEDXLot(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsINDEXLot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsINDEXLot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelection ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black"
                                                  name="marginDetailsDeliveryINDEX"
                                                  value={
                                                    marginDetailsINDEXAmount
                                                  }
                                                  // onChange={handleInputChange}
                                                  onChange={(e) => {
                                                    setMarginDetailsINDEXAmount(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsINDEXAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsINDEXAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                          {selectedRole !== "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MAXIMUM MARGIN LIMIT PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black text-nowrap "
                                                    name="maxMarginPerClientINDEX"
                                                    value={
                                                      maxMarginPerClientINDEX
                                                    }
                                                    onChange={(e) => {
                                                      setMaxMarginPerClientINDEX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {maxMarginPerClientINDEX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          maxMarginPerClientINDEX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={4} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingINDEXForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownINDEXForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group2"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsIndexRadioSelection ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsIndexRadioSelection(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="group2"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsIndexRadioSelection ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsIndexRadioSelection(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsIndexRadioSelection ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={scriptDetailsScript}
                                                  value={scriptDetailsScript.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownIndex.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownINDEX
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsIndexRadioSelection ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={blockedScriptDetails}
                                                  value={blockedScriptDetails.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownIndex.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownIndex
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>
                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={indexScriptToWork}
                                                onChange={(e) => {
                                                  setIndexScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={indexFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setIndexFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>
                                 
                                 {selectedRole === "111" ? (
                                  <> 
                                    <Row className="mt-1">
                                        <Col
                                          xl={12}
                                          className={`${
                                            !isMobile ? "ps-0 pe-1" : "ps-0 pe-1"
                                          }`}
                                        >
                                          <Card>
                                            <Card.Header className="fieldset-legend-title label-color mb-1">
                                              QUANTITY SETTINGS
                                            </Card.Header>
                                            <Card.Body>
                                              <Row>
                                                <Col xl={3}>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-0" : ""
                                                    }`}
                                                  >
                                                    COPY SETTINGS
                                                  </Form.Label>
                                                  <Select
                                                    options={copySettingOptions.map(
                                                      (item) => ({
                                                        value: item?.user?.userid,
                                                        label: `(${item?.user?.userName}) ${item?.user?.firstName}`
                                                      })
                                                    )}
                                                    value={
                                                      copySettingGLOBALForQuantitySettings
                                                    } // Filter selected values
                                                    onChange={
                                                      handleCopySettingDropdownGLOBALForQuantitySettings
                                                    } // Handle changes to selection
                                                    getOptionLabel={(e) => e.label}
                                                    placeholder="SELECT"
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    className="fss-01 small-select text-black"
                                                    theme={the}
                                                    styles={customStyles}
                                                  />
                                                </Col>
                                              </Row>

                                                <div>
                                                  {fieldsToRenderQtySettingsGLOBAL.map(
                                                      (inputField, index) => (
                                                        <Row
                                                          data-id={inputField.id}
                                                          className="mb-3"
                                                        >
                                                          <Col
                                                            xs={4}
                                                            xl={4}
                                                            className={`${
                                                              isMobile ? "ps-1" : ""
                                                            }`}
                                                          >
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              SCRIPT
                                                            </Form.Label>

                                                            <Select
                                                              options={
                                                                brokerageScripts
                                                              }
                                                              value={
                                                                brokerageScripts.find(
                                                                  (script) =>
                                                                    script.value ===
                                                                    inputField.script
                                                                ) || null
                                                              }
                                                              onChange={(
                                                                selectedOption
                                                              ) =>
                                                                handleQtySettingScriptDropdownGLOBAL(
                                                                  selectedOption,
                                                                  inputField.id
                                                                )
                                                              }
                                                              getOptionLabel={(e) =>
                                                                e.label
                                                              }
                                                              placeholder={
                                                                index === 0
                                                                  ? "All"
                                                                  : "Select"
                                                              }
                                                              isSearchable={true}
                                                              className="fss-01 small-select text-black ps-0"
                                                              theme={the}
                                                              isDisabled={
                                                                index === 0
                                                              }
                                                              styles={modelDropdown}
                                                            />

                                                          </Col>  
                                                          <Col
                                                            xs={2}
                                                            xl={2}
                                                            className={`${
                                                              isMobile ? "ps-1" : "ps-0"
                                                            }`}
                                                          >
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              MIN
                                                            </Form.Label>
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Min"
                                                              name="minOrder"
                                                              value={
                                                                inputField.minOrder
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeQtySettingsGLOBAL(
                                                                  e,
                                                                  "minOrder",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />
                                                          </Col>

                                                          <Col
                                                            xs={3}
                                                            xl={3}
                                                            className={`${
                                                              isMobile ? "ps-1" : "ps-0"
                                                            }`}
                                                          >
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              MAX
                                                            </Form.Label>
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Max"
                                                              name="maxOrder"
                                                              value={
                                                                inputField.maxOrder
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeQtySettingsGLOBAL(
                                                                  e,
                                                                  "maxOrder",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />
                                                          </Col>

                                                          <Col
                                                            xs={3}
                                                            xl={3}
                                                            className={`${
                                                              isMobile ? "ps-1" : "ps-0"
                                                            }`}
                                                          >
                                                            <Row>
                                                              <Col xs={11}>
                                                                <Form.Label
                                                                  className={`fss-875 label-color mb-1 text-nowrap ${
                                                                    !isMobile
                                                                      ? "mt-3"
                                                                      : "mt-3"
                                                                  }`}
                                                                >
                                                                  {" "}
                                                                  POSITION
                                                                </Form.Label>
                                                              </Col>
                                                            </Row>
                                                            <Row>
                                                              <Col
                                                                xs={12}
                                                                className="d-flex"
                                                                style={{
                                                                  display:
                                                                    "inline-block",
                                                                }}
                                                              >
                                                                <input
                                                                  type="number"
                                                                  className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                  placeholder="Position"
                                                                  name="positionLimit"
                                                                  value={
                                                                    inputField.positionLimit
                                                                  }
                                                                  onChange={(e) =>
                                                                    inputChangeQtySettingsGLOBAL(
                                                                      e,
                                                                      "positionLimit",
                                                                      inputField.id
                                                                    )
                                                                  }
                                                                />

                                                                {inputField.id ===
                                                                1 ? (
                                                                  <Col
                                                                    sm={1}
                                                                    data-id={
                                                                      inputField.id
                                                                    }
                                                                    className="d-flex mt-3 justify-content-center align-items-center "
                                                                  >
                                                                    {" "}
                                                                  </Col>
                                                                ) : (
                                                                  ""
                                                                )}
                                                                  {fieldsToRenderQtySettingsGLOBAL.length >
                                                                  1 &&
                                                                  fieldsToRenderQtySettingsGLOBAL.map(
                                                                    (
                                                                      field,
                                                                      index
                                                                    ) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.script !==
                                                                        "ALL" ? (
                                                                        index !==
                                                                        0 ? (
                                                                          <span
                                                                            className="text-danger cursor-pointer"
                                                                            style={{
                                                                              fontSize:
                                                                                "20px",
                                                                              fontWeight:
                                                                                "800",
                                                                            }}
                                                                            onClick={() =>
                                                                              handleRemoveFieldQtyGLOBAL(
                                                                                inputField.id
                                                                              )
                                                                            }
                                                                          >
                                                                            ×
                                                                          </span>
                                                                        ) : null
                                                                      ) : null
                                                                  )}
                                                              </Col>
                                                            </Row>
                                                          </Col>
                                                        </Row>
                                                      )
                                                    )}
                                                    <Row className="mt-1">
                                                      <Col>
                                                        <div className="text-end mt-3">
                                                          <Button
                                                            variant="success"
                                                            size="sm"
                                                            className="mt-1"
                                                            onClick={
                                                              handleAddFieldsGLOBALQtySettings
                                                            }
                                                          >
                                                            + Add
                                                          </Button>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </div>

                                          </Card.Body>
                                        </Card>
                                      </Col>
                                    </Row>    
                                    </>) : (
                                  <>
                                </>)}
                                
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModal}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                              <Modal
                                show={showModalMCX}
                                onHide={handleCloseModalMCX}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    MCX
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col
                                      xl={5}
                                      className={`${
                                        !isMobile ? "ps-0 pe-0" : "ps-0 pe-1"
                                      }`}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXorBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>

                                          {selectedRole === "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -5 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="MCX3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionMCX ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionMCX(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="MCX3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionMCX ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionMCX(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>

                                              <div>
                                                {fieldsToRenderMCX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScriptsMCX
                                                          }
                                                          value={
                                                            brokerageScriptsMCX.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionMCX
                                                          ) =>
                                                            handleBrokerageScriptDropdownMCX(
                                                              selectedOptionMCX,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsMCX(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsMCX(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}
                                                            {inputFieldsMCX.map(
                                                              (field, index) =>
                                                                inputField.id ===
                                                                  field.id &&
                                                                inputField.id !==
                                                                  1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                  <span
                                                                    className="text-danger cursor-pointer"
                                                                    style={{
                                                                      fontSize:
                                                                        "20px",
                                                                      fontWeight:
                                                                        "800",
                                                                    }}
                                                                    onClick={() =>
                                                                      handleRemoveFieldMCX(
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  >
                                                                    ×
                                                                  </span>
                                                                ) : null ) : (
                                                                  ""
                                                                )
                                                            )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}

                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsMCX
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                {selectedBroker1 &&
                                                  selectedBroker1?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker1?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForMCXBroker1.map(
                                                        (inputField, index) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsMCX
                                                                }
                                                                value={
                                                                  brokerageScriptsMCX.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForMCXBroker1(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  index === 0
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  index === 0
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsMCXForBroker1(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsMCXForBroker1(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForMCXBroker1.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForMCXBroker1(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForMCXBroker1
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                                {selectedBroker2 &&
                                                  selectedBroker2?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker2?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForMCXBroker2.map(
                                                        (inputField, index) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsMCX
                                                                }
                                                                value={
                                                                  brokerageScriptsMCX.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForMCXBroker2(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  index === 0
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  index === 0
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsMCXForBroker2(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsMCXForBroker2(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForMCXBroker2.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForMCXBroker2(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForMCXBroker2
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MIN % WISE BROKERAGE PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minPerBrokeragePerClientMCX"
                                                    value={
                                                      minPerBrokeragePerClientMCX
                                                    }
                                                    // onChange={handleInputChange}
                                                    onChange={(e) => {
                                                      setMinPerBrokeragePerClientMCX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minPerBrokeragePerClientMCX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minPerBrokeragePerClientMCX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>

                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MIN LOT WISE BROKERAGE
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minLotBrokeragePerClientMCX"
                                                    value={
                                                      minLotBrokeragePerClientMCX
                                                    }
                                                    onChange={(e) => {
                                                      setMinLotBrokeragePerClientMCX(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minLotBrokeragePerClientMCX ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minLotBrokeragePerClientMCX,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                              <div>
                                                {fieldsToRenderMCXRatherThanCustomerType.map(
                                                  (inputField) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mt-3 p-2"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Select
                                                          options={
                                                            brokerageScriptsMCX
                                                          }
                                                          value={
                                                            brokerageScriptsMCX.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionMCX
                                                          ) =>
                                                            handleBrokerageScriptDropdownMCXRatherThanCustomerType(
                                                              selectedOptionMCX,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder="Select"
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black text-nowrap"
                                                          placeholder="%"
                                                          name="mcxPercentage"
                                                          value={
                                                            inputField.mcxPercentage
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsForMCXRatherThanCustomerType(
                                                              e,
                                                              "mcxPercentage",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row></Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Lot"
                                                              name="mcxLot"
                                                              value={
                                                                inputField.mcxLot
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsForMCXRatherThanCustomerType(
                                                                  e,
                                                                  "mcxLot",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            <span
                                                              className="text-danger cursor-pointer"
                                                              style={{
                                                                fontSize:
                                                                  "20px",
                                                                fontWeight:
                                                                  "800",
                                                              }}
                                                              onClick={() =>
                                                                handleRemoveFieldMCXRatherThanCustomerType(
                                                                  inputField.id
                                                                )
                                                              }
                                                            >
                                                              ×
                                                            </span>
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}
                                              </div>
                                              <Row className="mt-1">
                                                <Col>
                                                  <div className="text-end mt-3">
                                                    <Button
                                                      variant="success"
                                                      size="sm"
                                                      className="mt-1"
                                                      onClick={
                                                        handleAddFieldsMCXRatherThanCustomerType
                                                      }
                                                    >
                                                      + Add
                                                    </Button>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col
                                      xl={3}
                                      className={
                                        isMobile
                                          ? "ps-0 pe-1 mt-2"
                                          : "ps-0 pe-1"
                                      }
                                      xs={isMobile ? 12 : 0}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div
                                                  key={`inline-${type}`}
                                                  style={{ marginTop: 5 }}
                                                >
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionMCX ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionMCX(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionMCX ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionMCX(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelectionMCX ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryMCX"
                                                  value={marginDetailsMCXLot}
                                                  onChange={(e) => {
                                                    setMarginDetailsMCXLot(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsMCXLot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsMCXLot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelectionMCX ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryMCX"
                                                  value={marginDetailsMCXAmount}
                                                  // onChange={handleInputChangeMCX}
                                                  onChange={(e) => {
                                                    setMarginDetailsMCXAmount(
                                                      e?.target?.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsMCXAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsMCXAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                          {selectedRole !== "CUSTOMER" ? (
                                            <>
                                              {marginDetailsRadioSelectionMCX ===
                                                "LOT" && (
                                                <Row>
                                                  <Col>
                                                    <Form.Label
                                                      className={`fss-875 label-color mb-1 text-nowrap ${
                                                        !isMobile ? "mt-3" : ""
                                                      }`}
                                                    >
                                                      MAXIMUM LOT LIMIT PER
                                                      CLEINT
                                                    </Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      size="sm"
                                                      className="fss-875 bg-white text-black text-nowrap "
                                                      name="maxLotPerClientMCX"
                                                      value={maxLotPerClientMCX}
                                                      onChange={(e) => {
                                                        setMaxLotPerClientMCX(
                                                          e?.target?.value
                                                        );
                                                      }}
                                                    />
                                                    {maxLotPerClientMCX ? (
                                                      <label className="word-color">
                                                        {" "}
                                                        {NumberToWordFormatter.numberToWordsIndian(
                                                          parseInt(
                                                            maxLotPerClientMCX,
                                                            10
                                                          )
                                                        )}{" "}
                                                      </label>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Col>
                                                </Row>
                                              )}
                                              {marginDetailsRadioSelectionMCX ===
                                                "AMOUNT" && (
                                                <Row>
                                                  <Col>
                                                    <Form.Label
                                                      className={`fss-875 label-color mb-1 text-nowrap ${
                                                        !isMobile ? "mt-3" : ""
                                                      }`}
                                                    >
                                                      MAXIMUM MARGIN LIMIT PER
                                                      CLEINT
                                                    </Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      size="sm"
                                                      className="fss-875 bg-white text-black text-nowrap "
                                                      name="maxMarginPerClientMCX"
                                                      value={
                                                        maxMarginPerClientMCX
                                                      }
                                                      onChange={(e) => {
                                                        setMaxMarginPerClientMCX(
                                                          e?.target?.value
                                                        );
                                                      }}
                                                    />
                                                    {maxMarginPerClientMCX ? (
                                                      <label className="word-color">
                                                        {" "}
                                                        {NumberToWordFormatter.numberToWordsIndian(
                                                          parseInt(
                                                            maxMarginPerClientMCX,
                                                            10
                                                          )
                                                        )}{" "}
                                                      </label>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Col>
                                                </Row>
                                              )}
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col
                                      xl={4}
                                      className={
                                        isMobile
                                          ? "ps-0 pe-1 mt-2"
                                          : "ps-0 pe-1"
                                      }
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div
                                                  key={`inline-${type}`}
                                                  style={{ marginTop: 5 }}
                                                >
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionMCX ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionMCX(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="MCX1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionMCX ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionMCX(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsRadioSelectionMCX ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    scriptDetailsScriptMCX
                                                  }
                                                  value={scriptDetailsScriptMCX.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownMCX.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter the selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownMCX
                                                  } // Handle changes to selection
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti // Allow multiple selections
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsRadioSelectionMCX ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    blockedScriptDetailsMCX
                                                  }
                                                  value={blockedScriptDetailsMCX.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownMCX.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownMCX
                                                  } // Handle selection change
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>

                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={mcxScriptToWork}
                                                onChange={(e) => {
                                                  setMCXScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={mcxFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setMcxFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>
                                
                                {selectedRole === "111" ? (
                                  <> 
                                 <Row className="mt-1">
                                    <Col
                                      xl={12}
                                      className={`${
                                        !isMobile ? "ps-0 pe-1" : "ps-0 pe-1"
                                      }`}
                                    >
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          LOT/QUANTITY SETTINGS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col xl={3}>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-0" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`
                                                  })
                                                )}
                                                value={
                                                  copySettingMCXForQuantitySettings
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownMCXForQuantitySettings
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT"
                                                isSearchable={true}
                                                isClearable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>

                                            <div>
                                              {fieldsToRenderQtySettingsMCX.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        xl={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SCRIPT
                                                        </Form.Label>

                                                        <Select
                                                          options={
                                                            brokerageScriptsMCX
                                                          }
                                                          value={
                                                            brokerageScriptsMCX.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.script
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOption
                                                          ) =>
                                                            handleQtySettingScriptDropdownMCX(
                                                              selectedOption,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={true}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={modelDropdown}
                                                        />

                                                      </Col>  
                                                      <Col
                                                        xs={2}
                                                        xl={2}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          MIN
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Min"
                                                          name="minOrder"
                                                          value={
                                                            inputField.minOrder
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeQtySettingsMCX(
                                                              e,
                                                              "minOrder",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>

                                                       <Col
                                                        xs={3}
                                                        xl={3}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          MAX
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Max"
                                                          name="maxOrder"
                                                          value={
                                                            inputField.maxOrder
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeQtySettingsMCX(
                                                              e,
                                                              "maxOrder",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>

                                                      <Col
                                                        xs={3}
                                                        xl={3}
                                                        className={`${
                                                          isMobile ? "ps-1" : "ps-0"
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              POSITION
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Position"
                                                              name="positionLimit"
                                                              value={
                                                                inputField.positionLimit
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeQtySettingsMCX(
                                                                  e,
                                                                  "positionLimit",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}
                                                              {fieldsToRenderQtySettingsMCX.length >
                                                              1 &&
                                                              fieldsToRenderQtySettingsMCX.map(
                                                                (
                                                                  field,
                                                                  index
                                                                ) =>
                                                                  inputField.id ===
                                                                    field.id &&
                                                                  inputField.script !==
                                                                    "ALL" ? (
                                                                    index !==
                                                                    0 ? (
                                                                      <span
                                                                        className="text-danger cursor-pointer"
                                                                        style={{
                                                                          fontSize:
                                                                            "20px",
                                                                          fontWeight:
                                                                            "800",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleRemoveFieldQtyMCX(
                                                                            inputField.id
                                                                          )
                                                                        }
                                                                      >
                                                                        ×
                                                                      </span>
                                                                    ) : null
                                                                  ) : null
                                                              )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}
                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsMCXQtySettings
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                      </Card.Body>
                                    </Card>
                                  </Col>
                                </Row>    
                                </>) : (
                              <>
                                </>)}

                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModalMCX}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                              {/* nseSetting NSE */}

                              <Modal
                                show={showModalNSE}
                                onHide={handleCloseModalNSE}
                                size="xl"
                              >
                                <Modal.Header>
                                  <Modal.Title className="modal-title-center">
                                    NSE
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Row className="mt-1">
                                    <Col xl={5} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          BROKERAGE DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForBrokerageDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForBrokerageDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          {selectedRole === "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile
                                                        ? "mt-3"
                                                        : "mt-3"
                                                    }`}
                                                  >
                                                    TYPE
                                                  </Form.Label>
                                                  {["radio"].map((type) => (
                                                    <div
                                                      key={`inline-${type}`}
                                                      style={{ marginTop: -10 }}
                                                    >
                                                      <Form.Check
                                                        inline
                                                        label="LOT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="NSE3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionNSE ===
                                                          "LOT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionNSE(
                                                            "LOT"
                                                          )
                                                        }
                                                      />
                                                      <Form.Check
                                                        inline
                                                        label="PERCENT"
                                                        className="fss-875 label-color custom-radio"
                                                        name="NSE3"
                                                        type={type}
                                                        checked={
                                                          radioSelectionNSE ===
                                                          "PERCENT"
                                                        }
                                                        onChange={() =>
                                                          setRadioSelectionNSE(
                                                            "PERCENT"
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                  ))}
                                                </Col>
                                              </Row>
                                              <div>
                                                {fieldsToRender.map(
                                                  (inputField, index) => (
                                                    <Row
                                                      data-id={inputField.id}
                                                      className="mb-3"
                                                    >
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          SELECT SCRIPT
                                                        </Form.Label>
                                                        <Select
                                                          options={
                                                            brokerageScriptsNSE
                                                          }
                                                          value={
                                                            brokerageScriptsNSE.find(
                                                              (script) =>
                                                                script.value ===
                                                                inputField.selectedScript
                                                            ) || null
                                                          }
                                                          onChange={(
                                                            selectedOptionNSE
                                                          ) =>
                                                            handleBrokerageScriptDropdownNSE(
                                                              selectedOptionNSE,
                                                              inputField.id
                                                            )
                                                          }
                                                          getOptionLabel={(e) =>
                                                            e.label
                                                          }
                                                          placeholder={
                                                            index === 0
                                                              ? "All"
                                                              : "Select"
                                                          }
                                                          isSearchable={false}
                                                          className="fss-01 small-select text-black ps-0"
                                                          theme={the}
                                                          // isDisabled={
                                                          //   inputField.id === 1
                                                          //     ? true
                                                          //     : false
                                                          // }
                                                          isDisabled={
                                                            index === 0
                                                          }
                                                          styles={customStyles}
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Form.Label
                                                          className={`fss-875 label-color mb-1 text-nowrap ${
                                                            !isMobile
                                                              ? "mt-3"
                                                              : "mt-3"
                                                          }`}
                                                        >
                                                          {" "}
                                                          DELIVERY COM
                                                        </Form.Label>
                                                        <input
                                                          type="number"
                                                          className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                          placeholder="Delivery"
                                                          name="deliveryCom"
                                                          value={
                                                            inputField.deliveryCom
                                                          }
                                                          onChange={(e) =>
                                                            inputChangeBrokerageDetailsNSE(
                                                              e,
                                                              "deliveryCom",
                                                              inputField.id
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                      <Col
                                                        xs={4}
                                                        className={`${
                                                          isMobile ? "ps-1" : ""
                                                        }`}
                                                      >
                                                        <Row>
                                                          <Col xs={11}>
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              INTRADAY COM
                                                            </Form.Label>
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col
                                                            xs={12}
                                                            className="d-flex"
                                                            style={{
                                                              display:
                                                                "inline-block",
                                                            }}
                                                          >
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Intraday"
                                                              name="intradayCom"
                                                              value={
                                                                inputField.intradayCom
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeBrokerageDetailsNSE(
                                                                  e,
                                                                  "intradayCom",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />

                                                            {inputField.id ===
                                                            1 ? (
                                                              <Col
                                                                sm={1}
                                                                data-id={
                                                                  inputField.id
                                                                }
                                                                className="d-flex mt-3 justify-content-center align-items-center "
                                                              >
                                                                {" "}
                                                              </Col>
                                                            ) : (
                                                              ""
                                                            )}

                                                            {inputFieldsNSE.map(
                                                              (field, index) =>
                                                                inputField.id ===
                                                                  field.id &&
                                                                inputField.id !==
                                                                  1 ? (
                                                                    index !==
                                                                    0 ? (
                                                                  <span
                                                                    className="text-danger cursor-pointer"
                                                                    style={{
                                                                      fontSize:
                                                                        "20px",
                                                                      fontWeight:
                                                                        "800",
                                                                    }}
                                                                    onClick={() =>
                                                                      handleRemoveFieldNSE(
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  >
                                                                    ×
                                                                  </span>
                                                                ) : null
                                                                ) : null
                                                            )}
                                                          </Col>
                                                        </Row>
                                                      </Col>
                                                    </Row>
                                                  )
                                                )}

                                                <Row className="mt-1">
                                                  <Col>
                                                    <div className="text-end mt-3">
                                                      <Button
                                                        variant="success"
                                                        size="sm"
                                                        className="mt-1"
                                                        onClick={
                                                          handleAddFieldsNSE
                                                        }
                                                      >
                                                        + Add
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                {selectedBroker1 &&
                                                  selectedBroker1?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker1?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForNSEBroker1.map(
                                                        (inputField, index) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsNSE
                                                                }
                                                                value={
                                                                  brokerageScriptsNSE.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForNSEBroker1(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  index === 0
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  index === 0
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsNSEForBroker1(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsNSEForBroker1(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />
                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForNSEBroker1.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForNSEBroker1(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForNSEBroker1
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                                {selectedBroker2 &&
                                                  selectedBroker2?.label && (
                                                    <>
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <lagend className="brokerInfo-title">
                                                            {
                                                              selectedBroker2?.label
                                                            }
                                                          </lagend>
                                                        </Col>
                                                      </Row>
                                                      {fieldsToRenderForNSEBroker2.map(
                                                        (inputField, index) => (
                                                          <Row
                                                            data-id={
                                                              inputField.id
                                                            }
                                                            className="mb-3"
                                                          >
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                SELECT SCRIPT
                                                              </Form.Label>
                                                              <Select
                                                                options={
                                                                  brokerageScriptsNSE
                                                                }
                                                                value={
                                                                  brokerageScriptsNSE.find(
                                                                    (script) =>
                                                                      script.value ===
                                                                      inputField.selectedScript
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption
                                                                ) =>
                                                                  handleBrokerageScriptDropdownForNSEBroker2(
                                                                    selectedOption,
                                                                    inputField.id
                                                                  )
                                                                }
                                                                getOptionLabel={(
                                                                  e
                                                                ) => e.label}
                                                                placeholder={
                                                                  index === 0
                                                                    ? "All"
                                                                    : "Select"
                                                                }
                                                                isSearchable={
                                                                  false
                                                                }
                                                                className="fss-01 small-select text-black ps-0"
                                                                theme={the}
                                                                isDisabled={
                                                                  index === 0
                                                                }
                                                                styles={
                                                                  customStyles
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Form.Label
                                                                className={`fss-875 label-color mb-1 text-nowrap ${
                                                                  !isMobile
                                                                    ? "mt-3"
                                                                    : "mt-3"
                                                                }`}
                                                              >
                                                                {" "}
                                                                DELIVERY COM
                                                              </Form.Label>
                                                              <input
                                                                type="number"
                                                                className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                placeholder="Delivery"
                                                                name="deliveryCom"
                                                                value={
                                                                  inputField.deliveryCom
                                                                }
                                                                onChange={(e) =>
                                                                  inputChangeBrokerageDetailsNSEForBroker2(
                                                                    e,
                                                                    "deliveryCom",
                                                                    inputField.id
                                                                  )
                                                                }
                                                              />
                                                            </Col>
                                                            <Col
                                                              xs={4}
                                                              className={`${
                                                                isMobile
                                                                  ? "ps-1"
                                                                  : ""
                                                              }`}
                                                            >
                                                              <Row>
                                                                <Col xs={11}>
                                                                  <Form.Label
                                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                                      !isMobile
                                                                        ? "mt-3"
                                                                        : "mt-3"
                                                                    }`}
                                                                  >
                                                                    {" "}
                                                                    INTRADAY COM
                                                                  </Form.Label>
                                                                </Col>
                                                              </Row>
                                                              <Row>
                                                                <Col
                                                                  xs={12}
                                                                  className="d-flex"
                                                                  style={{
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <input
                                                                    type="number"
                                                                    className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                    placeholder="Intraday"
                                                                    name="intradayCom"
                                                                    value={
                                                                      inputField.intradayCom
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      inputChangeBrokerageDetailsNSEForBroker2(
                                                                        e,
                                                                        "intradayCom",
                                                                        inputField.id
                                                                      )
                                                                    }
                                                                  />

                                                                  {inputField.id ===
                                                                  1 ? (
                                                                    <Col
                                                                      sm={1}
                                                                      data-id={
                                                                        inputField.id
                                                                      }
                                                                      className="d-flex mt-3 justify-content-center align-items-center "
                                                                    >
                                                                      {" "}
                                                                    </Col>
                                                                  ) : (
                                                                    ""
                                                                  )}
                                                                  {inputFieldsForNSEBroker2.map(
                                                                    (field) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.id !==
                                                                        1 ? (
                                                                        <span
                                                                          className="text-danger cursor-pointer"
                                                                          style={{
                                                                            fontSize:
                                                                              "20px",
                                                                            fontWeight:
                                                                              "800",
                                                                          }}
                                                                          onClick={() =>
                                                                            handleRemoveFieldForNSEBroker2(
                                                                              inputField.id
                                                                            )
                                                                          }
                                                                        >
                                                                          ×
                                                                        </span>
                                                                      ) : null
                                                                  )}
                                                                </Col>
                                                              </Row>
                                                            </Col>
                                                          </Row>
                                                        )
                                                      )}
                                                      <Row className="mt-1">
                                                        <Col>
                                                          <div className="text-end mt-3">
                                                            <Button
                                                              variant="success"
                                                              size="sm"
                                                              className="mt-1"
                                                              onClick={
                                                                handleAddFieldsForNSEBroker2
                                                              }
                                                            >
                                                              + Add
                                                            </Button>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    </>
                                                  )}
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MIN % WISE BROKERAGE PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black "
                                                    name="minPerBrokeragePerClientNSE"
                                                    value={
                                                      minPerBrokeragePerClientNSE
                                                    }
                                                    // onChange={handleInputChange}
                                                    onChange={(e) => {
                                                      setMinPerBrokeragePerClientNSE(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {minPerBrokeragePerClientNSE ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          minPerBrokeragePerClientNSE,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            </>
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={3} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          MARGIN DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForMarginDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForMarginDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="LOT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionNSE ===
                                                      "LOT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionNSE(
                                                        "LOT"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="AMOUNT"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE2"
                                                    type={type}
                                                    checked={
                                                      marginDetailsRadioSelectionNSE ===
                                                      "AMOUNT"
                                                    }
                                                    onChange={() =>
                                                      handleRadioSelectionNSE(
                                                        "AMOUNT"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {marginDetailsRadioSelectionNSE ===
                                            "LOT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL LOT WISE(DELIVERY)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryNSE"
                                                  value={marginDetailsNSELot}
                                                  onChange={(e) => {
                                                    setMarginDetailsNSELot(
                                                      e.target.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsNSELot ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsNSELot,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}
                                          {marginDetailsRadioSelectionNSE ===
                                            "AMOUNT" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  TOTAL AMOUNT WISE(MARGIN)
                                                </Form.Label>
                                                <Form.Control
                                                  type="number"
                                                  size="sm"
                                                  className="fss-875 bg-white text-black "
                                                  name="marginDetailsDeliveryNSE"
                                                  value={marginDetailsNSEAmount}
                                                  // onChange={handleInputChangeNSE}
                                                  onChange={(e) => {
                                                    setMarginDetailsNSEAmount(
                                                      e.target.value
                                                    );
                                                  }}
                                                />
                                                {marginDetailsNSEAmount ? (
                                                  <label className="word-color">
                                                    {" "}
                                                    {NumberToWordFormatter.numberToWordsIndian(
                                                      parseInt(
                                                        marginDetailsNSEAmount,
                                                        10
                                                      )
                                                    )}{" "}
                                                  </label>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </Row>
                                          )}

                                          {selectedRole !== "CUSTOMER" ? (
                                            <>
                                              <Row>
                                                <Col>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 text-nowrap ${
                                                      !isMobile ? "mt-3" : ""
                                                    }`}
                                                  >
                                                    MAXIMUM MARGIN LIMIT PER
                                                    CLEINT
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="fss-875 bg-white text-black text-nowrap "
                                                    name="maxMarginPerClientNSE"
                                                    value={
                                                      maxMarginPerClientNSE
                                                    }
                                                    onChange={(e) => {
                                                      setMaxMarginPerClientNSE(
                                                        e?.target?.value
                                                      );
                                                    }}
                                                  />
                                                  {maxMarginPerClientNSE ? (
                                                    <label className="word-color">
                                                      {" "}
                                                      {NumberToWordFormatter.numberToWordsIndian(
                                                        parseInt(
                                                          maxMarginPerClientNSE,
                                                          10
                                                        )
                                                      )}{" "}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </Row>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                    <Col xl={4} className="ps-0 pe-1">
                                      <Card>
                                        <Card.Header className="fieldset-legend-title label-color mb-1">
                                          OTHER DETAILS
                                        </Card.Header>
                                        <Card.Body>
                                          <Row>
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                COPY SETTINGS
                                              </Form.Label>
                                              <Select
                                                options={copySettingOptions.map(
                                                  (item) => ({
                                                    value: item?.user?.userid,
                                                    label: `(${item?.user?.userName}) ${item?.user?.firstName}`,
                                                    copySettings:
                                                      item?.settings,
                                                  })
                                                )}
                                                value={
                                                  copySettingNSEForOtherDetails
                                                } // Filter selected values
                                                onChange={
                                                  handleCopySettingDropdownNSEForOtherDetails
                                                } // Handle changes to selection
                                                getOptionLabel={(e) => e.label}
                                                placeholder="SELECT ID"
                                                isSearchable={true}
                                                className="fss-01 small-select text-black"
                                                theme={the}
                                                styles={customStyles}
                                              />
                                            </Col>
                                          </Row>
                                          <Row className="pt-2">
                                            <Col>
                                              {["radio"].map((type) => (
                                                <div key={`inline-${type}`}>
                                                  <Form.Check
                                                    inline
                                                    label="ALLOW"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionNSE ===
                                                      "ALLOW"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionNSE(
                                                        "ALLOW"
                                                      )
                                                    }
                                                  />
                                                  <Form.Check
                                                    inline
                                                    label="BLOCK"
                                                    className="fss-875 label-color custom-radio"
                                                    name="NSE1"
                                                    type={type}
                                                    checked={
                                                      scriptDetailsRadioSelectionNSE ===
                                                      "BLOCK"
                                                    }
                                                    onChange={() =>
                                                      setScriptDetailsRadioSelectionNSE(
                                                        "BLOCK"
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ))}
                                            </Col>
                                          </Row>
                                          {scriptDetailsRadioSelectionNSE ===
                                            "ALLOW" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  ALLOW SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    scriptDetailsScriptNSE
                                                  }
                                                  value={scriptDetailsScriptNSE?.filter(
                                                    (scriptDeatails) =>
                                                      scriptDeatailsDropdownNSE.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter based on the selected values
                                                  onChange={
                                                    handleScriptDetailsDropdownNSE
                                                  } // Handle change
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          {scriptDetailsRadioSelectionNSE ===
                                            "BLOCK" && (
                                            <Row>
                                              <Col>
                                                <Form.Label
                                                  className={`fss-875 label-color mb-1 ${
                                                    !isMobile ? "mt-2" : ""
                                                  }`}
                                                >
                                                  BLOCK SCRIPTS
                                                </Form.Label>
                                                <Select
                                                  options={
                                                    blockedScriptDetailsNSE
                                                  }
                                                  value={blockedScriptDetailsNSE?.filter(
                                                    (scriptDeatails) =>
                                                      blockedScriptDropdownNSE.includes(
                                                        scriptDeatails.value
                                                      )
                                                  )} // Filter selected values
                                                  onChange={
                                                    handleBlockedScriptDropdownNSE
                                                  } // Handle changes
                                                  getOptionLabel={(e) =>
                                                    e.label
                                                  }
                                                  placeholder="Select Script"
                                                  isSearchable={true}
                                                  className="fss-875 small-select text-black"
                                                  theme={the}
                                                  styles={customStyles}
                                                  isMulti
                                                />
                                              </Col>
                                            </Row>
                                          )}
                                          <Row className="">
                                            <Col>
                                              <Form.Label
                                                className={`fss-875 label-color mb-1 ${
                                                  !isMobile ? "mt-2" : ""
                                                }`}
                                              >
                                                HOW MANY SCRIPTS TO WORK IN
                                              </Form.Label>

                                              <Form.Control
                                                type="number"
                                                size="sm"
                                                className="fss-875 bg-white text-black "
                                                name="howManyScriptToWorkIn"
                                                value={NseScriptToWork}
                                                onChange={(e) => {
                                                  setNSEScriptToWork(
                                                    e.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <Form.Check
                                                aria-label="option 1"
                                                type="checkbox"
                                                label="FRESH LIMIT ALLOWED?"
                                                className="custom-checkbox label-color fss-875 mt-3"
                                                checked={nseFreshLimitAllowed}
                                                onChange={(e) => {
                                                  setNseFreshLimitAllowed(
                                                    e.target.checked
                                                  );
                                                }}
                                                name="index"
                                              />
                                            </Col>
                                          </Row>
                                        </Card.Body>
                                      </Card>
                                    </Col>
                                  </Row>
                                  
                                   {selectedRole === "111" ? (
                                      <> 
                                      <Row className="mt-1">
                                        <Col
                                          xl={12}
                                          className={`${
                                            !isMobile ? "ps-0 pe-1" : "ps-0 pe-1"
                                          }`}
                                        >
                                          <Card>
                                            <Card.Header className="fieldset-legend-title label-color mb-1">
                                              QUANTITY SETTINGS
                                            </Card.Header>
                                            <Card.Body>
                                              <Row>
                                                <Col xl={3}>
                                                  <Form.Label
                                                    className={`fss-875 label-color mb-1 ${
                                                      !isMobile ? "mt-0" : ""
                                                    }`}
                                                  >
                                                    COPY SETTINGS
                                                  </Form.Label>
                                                  <Select
                                                    options={copySettingOptions.map(
                                                      (item) => ({
                                                        value: item?.user?.userid,
                                                        label: `(${item?.user?.userName}) ${item?.user?.firstName}`
                                                      })
                                                    )}
                                                    value={
                                                      copySettingNSEForQuantitySettings
                                                    } // Filter selected values
                                                    onChange={
                                                      handleCopySettingDropdownNSEForQuantitySettings
                                                    } // Handle changes to selection
                                                    getOptionLabel={(e) => e.label}
                                                    placeholder="SELECT"
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    className="fss-01 small-select text-black"
                                                    theme={the}
                                                    styles={customStyles}
                                                  />
                                                </Col>
                                              </Row>
    
                                                <div>
                                                  {fieldsToRenderQtySettingsNSE.map(
                                                      (inputField, index) => (
                                                        <Row
                                                          data-id={inputField.id}
                                                          className="mb-3"
                                                        >
                                                          <Col
                                                            xs={4}
                                                            xl={4}
                                                            className={`${
                                                              isMobile ? "ps-1" : ""
                                                            }`}
                                                          >
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              SCRIPT
                                                            </Form.Label>
    
                                                            <Select
                                                              options={
                                                                brokerageScriptsNSE
                                                              }
                                                              value={
                                                                brokerageScriptsNSE.find(
                                                                  (script) =>
                                                                    script.value ===
                                                                    inputField.script
                                                                ) || null
                                                              }
                                                              onChange={(
                                                                selectedOption
                                                              ) =>
                                                                handleQtySettingScriptDropdownNSE(
                                                                  selectedOption,
                                                                  inputField.id
                                                                )
                                                              }
                                                              getOptionLabel={(e) =>
                                                                e.label
                                                              }
                                                              placeholder={
                                                                index === 0
                                                                  ? "All"
                                                                  : "Select"
                                                              }
                                                                isSearchable={true}
                                                              className="fss-01 small-select text-black ps-0"
                                                              theme={the}
                                                              isDisabled={
                                                                index === 0
                                                              }
                                                              styles={modelDropdown}
                                                            />
    
                                                          </Col>  
                                                          <Col
                                                            xs={2}
                                                            xl={2}
                                                            className={`${
                                                              isMobile ? "ps-1" : "ps-0"
                                                            }`}
                                                          >
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              MIN
                                                            </Form.Label>
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Min"
                                                              name="minOrder"
                                                              value={
                                                                inputField.minOrder
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeQtySettingsNSE(
                                                                  e,
                                                                  "minOrder",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />
                                                          </Col>
    
                                                            <Col
                                                            xs={3}
                                                            xl={3}
                                                            className={`${
                                                              isMobile ? "ps-1" : "ps-0"
                                                            }`}
                                                          >
                                                            <Form.Label
                                                              className={`fss-875 label-color mb-1 text-nowrap ${
                                                                !isMobile
                                                                  ? "mt-3"
                                                                  : "mt-3"
                                                              }`}
                                                            >
                                                              {" "}
                                                              MAX
                                                            </Form.Label>
                                                            <input
                                                              type="number"
                                                              className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                              placeholder="Max"
                                                              name="maxOrder"
                                                              value={
                                                                inputField.maxOrder
                                                              }
                                                              onChange={(e) =>
                                                                inputChangeQtySettingsNSE(
                                                                  e,
                                                                  "maxOrder",
                                                                  inputField.id
                                                                )
                                                              }
                                                            />
                                                          </Col>
    
                                                          <Col
                                                            xs={3}
                                                            xl={3}
                                                            className={`${
                                                              isMobile ? "ps-1" : "ps-0"
                                                            }`}
                                                          >
                                                            <Row>
                                                              <Col xs={11}>
                                                                <Form.Label
                                                                  className={`fss-875 label-color mb-1 text-nowrap ${
                                                                    !isMobile
                                                                      ? "mt-3"
                                                                      : "mt-3"
                                                                  }`}
                                                                >
                                                                  {" "}
                                                                  POSITION
                                                                </Form.Label>
                                                              </Col>
                                                            </Row>
                                                            <Row>
                                                              <Col
                                                                xs={12}
                                                                className="d-flex"
                                                                style={{
                                                                  display:
                                                                    "inline-block",
                                                                }}
                                                              >
                                                                <input
                                                                  type="number"
                                                                  className="form-control bg-light form-control-md fss-875 custom-placeholder text-black"
                                                                  placeholder="Position"
                                                                  name="positionLimit"
                                                                  value={
                                                                    inputField.positionLimit
                                                                  }
                                                                  onChange={(e) =>
                                                                    inputChangeQtySettingsNSE(
                                                                      e,
                                                                      "positionLimit",
                                                                      inputField.id
                                                                    )
                                                                  }
                                                                />
    
                                                                {inputField.id ===
                                                                1 ? (
                                                                  <Col
                                                                    sm={1}
                                                                    data-id={
                                                                      inputField.id
                                                                    }
                                                                    className="d-flex mt-3 justify-content-center align-items-center "
                                                                  >
                                                                    {" "}
                                                                  </Col>
                                                                ) : (
                                                                  ""
                                                                )}
                                                                  {fieldsToRenderQtySettingsNSE.length >
                                                                  1 &&
                                                                  fieldsToRenderQtySettingsNSE.map(
                                                                    (
                                                                      field,
                                                                      index
                                                                    ) =>
                                                                      inputField.id ===
                                                                        field.id &&
                                                                      inputField.script !==
                                                                        "ALL" ? (
                                                                        index !==
                                                                        0 ? (
                                                                          <span
                                                                            className="text-danger cursor-pointer"
                                                                            style={{
                                                                              fontSize:
                                                                                "20px",
                                                                              fontWeight:
                                                                                "800",
                                                                            }}
                                                                            onClick={() =>
                                                                              handleRemoveFieldQtyNSE(
                                                                                inputField.id
                                                                              )
                                                                            }
                                                                          >
                                                                            ×
                                                                          </span>
                                                                        ) : null
                                                                      ) : null
                                                                  )}
                                                              </Col>
                                                            </Row>
                                                          </Col>
                                                        </Row>
                                                      )
                                                    )}
                                                    <Row className="mt-1">
                                                      <Col>
                                                        <div className="text-end mt-3">
                                                          <Button
                                                            variant="success"
                                                            size="sm"
                                                            className="mt-1"
                                                            onClick={
                                                              handleAddFieldsNSEQtySettings
                                                            }
                                                          >
                                                            + Add
                                                          </Button>
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </div>
    
                                          </Card.Body>
                                        </Card>
                                      </Col>
                                    </Row>    
                                    </>) : (
                                  <>
                                    </>)}

                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="danger"
                                    onClick={handleCloseModalNSE}
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </Row>
                            <Row>
                              <Col></Col>
                              <Col></Col>
                              <Col></Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    {selectedRole === "CUSTOMER" && (
                      <>
                        <Col xs={12} xl={4} className="mt-1">
                          <Card className={isMobile ? "me-0" : "me-2"}>
                            <Card.Body className="pt-0">
                              <div>
                                <Row>
                                  <lagend className="fieldset-legend-title label-color">
                                    BROKER INFO
                                  </lagend>
                                </Row>
                                <Row className="mt-1">
                                  <Col sm={6}>
                                    <b className="fss-875 label-color">
                                      BROKER 1
                                    </b>
                                    <Select
                                      options={subBroker.map((item) => ({
                                        value: item.adminId,
                                        label: `${item.firstName} (${item.userName})`,
                                      }))}
                                      onChange={handleSubBrokerDropdown}
                                      isSearchable
                                      isClearable
                                      placeholder="Select"
                                      value={selectedBroker1}
                                      className="text-black"
                                      theme={the}
                                      styles={customStyles}
                                    />
                                  </Col>
                                  <Col sm={6}>
                                    <b className="fss-875 label-color">
                                      BROKER PARTNERSHIP
                                    </b>
                                    <Form.Control
                                      type="number"
                                      size="sm"
                                      className="fs-7 bg-white text-black custom-placeholder"
                                      name="selectBrokerPartner"
                                      value={selectBrokerPartner}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                          setSelectBrokerPartner(value);
                                        }
                                      }}
                                      placeholder="Enter Broker Name"
                                      inputMode="numeric"
                                    />
                                  </Col>
                                </Row>
                                <Row className="mt-1">
                                  <Col sm={6}>
                                    <b className="fss-875 label-color">
                                      BROKER 2
                                    </b>
                                    <Select
                                      options={subBroker.map((item) => ({
                                        value: item.adminId,
                                        label: `${item.firstName} (${item.userName})`,
                                      }))}
                                      onChange={handleSubBroker2Dropdown}
                                      isSearchable
                                      isClearable
                                      placeholder="Select"
                                      value={selectedBroker2}
                                      className="text-black"
                                      theme={the}
                                      styles={customStyles}
                                    />
                                  </Col>
                                  <Col sm={6}>
                                    <b className="fss-875 label-color">
                                      BROKER PARTNERSHIP
                                    </b>
                                    <Form.Control
                                      type="number"
                                      size="sm"
                                      className="fs-7 bg-white text-black custom-placeholder"
                                      name="selectBrokerPartner2"
                                      value={selectBrokerPartner2}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                          setSelectBrokerPartner2(value);
                                        }
                                      }}
                                      placeholder="Enter Broker Name"
                                      inputMode="numeric"
                                    />
                                  </Col>
                                </Row>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      </>
                    )}
                    <Col xs={12} xl={4} className="mt-1">
                      <Card>
                        <Card.Body className="pt-0">
                          <div>
                            <Row>
                              <lagend className="fieldset-legend-title label-color">
                                REMARK
                              </lagend>
                            </Row>
                            <Row className="ms-1 me-1">
                              <Form.Control
                                as="textarea"
                                type="text"
                                className="mt-2  text-black bg-white custom-placeholder"
                                placeholder="Remark"
                                name="remark"
                              />
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </>
            )}
            <div className="text-center">
              <Button
                className="mt-3 w-25 market-access"
                size="sm"
                variant="success"
                type="submit"
              >
                SUBMIT
              </Button>
            </div>
            <Row className="mt-5"></Row>
          </div>
        )}
      </Form>
    </div>
  );
}
export default EditAccount;
